export interface Exhibitor {
  id: string
  name: string
  logo: string
  industries: string[]
  headquarters: string | null
  events: string[]
  email: string | null
  socials: { logo: string; link: string }[] | null
  sponsor: string | null
  standNumber: string
  standType: 'Space Only' | 'Shell Scheme' | 'Show Ready' | 'Pod' | 'Brand Only'
  website: string
  description: string
  isFavorite?: boolean
  profileStatus?: 'basic' | 'pending-setup' | 'complete'
  parentExhibitorId?: string | null
}

export const exhibitors: Exhibitor[] = [
  // First batch - existing 30 exhibitors
  {
    id: '1',
    name: 'ORBIT4',
    logo: 'https://a.storyblok.com/f/282702/2a845f6cde/20251016174730_gulf-active-industry-network-gain_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Equipment', 'Technology'],
    headquarters: 'UK',
    events: ['DAI'],
    email: 'info@orbit4.org',
    socials: [
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/72349537/',
      },
    ],
    sponsor: null,
    standNumber: 'GP4',
    standType: 'Shell Scheme',
    website: 'https://orbit4.org/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '2',
    name: "Farah Secret's",
    logo: 'https://a.storyblok.com/f/282702/e9bebd1560/20251016140749_spider-labs_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor', 'Wellness'],
    headquarters: 'Hungary',
    events: ['DMS'],
    email: 'admin@pharmagenhealthcare.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/farah_secrets_byguru',
      },
    ],
    sponsor: null,
    standNumber: 'C16',
    standType: 'Brand Only',
    website: 'https://www.farahsecrets.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '3',
    name: 'Fade Fit',
    logo: 'https://a.storyblok.com/f/282702/daabb1c8ed/20251016110612_fade-general-trading-fade-fit_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'brianna@fadefit.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fadefit',
      },
    ],
    sponsor: null,
    standNumber: 'D5B',
    standType: 'Space Only',
    website: 'https://www.FadeFit.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '4',
    name: 'COREV',
    logo: 'https://a.storyblok.com/f/282702/54701624af/20250715064115_core-velocity-sport-machine-trading-llc_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Hospitality',
      'Technology',
      'Education & Training',
      'Recovery',
      'Training Provider',
      'Equipment',
      'Gym',
      'Wellness',
      'Equipment Distributor',
      'Gym Accessories',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@core-velocity.com',
    socials: null,
    sponsor: null,
    standNumber: 'H1b',
    standType: 'Show Ready',
    website: 'https://www.oxefit.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '5',
    name: 'Rolla',
    logo: 'https://a.storyblok.com/f/282702/7efd605e82/20251014102551_rolla-holdco-ltd_cropped.jpg',
    industries: ['Fitness', 'Technology'],
    headquarters: 'UK',
    events: ['DAS'],
    email: 'hello@rolla.app',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/lifeatrolla',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/rollaapp',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/lifeatrolla',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/@rolla-app',
      },
    ],
    sponsor: null,
    standNumber: 'F5B',
    standType: 'Pod',
    website: 'https://rolla.app',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '6',
    name: 'Trueform Runner',
    logo: 'https://a.storyblok.com/f/282702/152928f673/20251015074050_elite-athlete-middle-east-llc_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Fitness Franchise', 'Equipment'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'asif@eliteathlete.ae',
    socials: null,
    sponsor: null,
    standNumber: 'F4C',
    standType: 'Brand Only',
    website: 'https://eliteathlete.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '7',
    name: 'XBody & Ultima',
    logo: 'https://a.storyblok.com/f/282702/22741912d8/20250915135653_xbody-hungary_cropped.jpg',
    industries: [
      'Equipment',
      'Beauty & Wellness',
      'Beauty',
      'Wellness',
      'Gym Accessories',
      'Education & Training',
      'Fitness',
    ],
    headquarters: 'Hungary',
    events: ['DAI'],
    email: 'sales@xbodyworld.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/xbody_world/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/xbodyworld',
      },
    ],
    sponsor: null,
    standNumber: 'H1d',
    standType: 'Space Only',
    website: 'https://xbodyworld.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '8',
    name: 'AURAFAMILY',
    logo: 'https://a.storyblok.com/f/282702/6b527c3232/20251014114747_aura-family-fz-llc_cropped.jpg',
    industries: ['Nutrition', 'Beauty & Wellness', 'Fitness', 'Wellness'],
    headquarters: 'Canada',
    events: ['DMS'],
    email: 'amir.hosseini@theaurafamily.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/aurafamilymena/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/theaurafamily',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@AurafamilyMena',
      },
    ],
    sponsor: null,
    standNumber: 'G9D',
    standType: 'Brand Only',
    website: 'https://theaurafamily.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '9',
    name: 'Goorin Bros. and Happy Socks',
    logo: 'https://a.storyblok.com/f/282702/66656fa201/20251009070510_si-fashion-galerie-fz-llc_cropped.jpg',
    industries: ['Apparel', 'Others', 'Distributor'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@si-fashion.com',
    socials: null,
    sponsor: null,
    standNumber: 'C8B',
    standType: 'Space Only',
    website: 'https://si-fashion.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '10',
    name: 'Fitsnack',
    logo: 'https://a.storyblok.com/f/282702/3d8b86b5f6/20250903075322_fitsnack-fze_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'info@fitsnack.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fitsnack.mena/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/100372191/',
      },
    ],
    sponsor: null,
    standNumber: 'C12b',
    standType: 'Brand Only',
    website: 'https://fitsnack.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '11',
    name: 'ODYSSEY PLUNGE',
    logo: 'https://a.storyblok.com/f/282702/75178a077f/20251004202613_odyssey-plunge-fz-llc_cropped.jpg',
    industries: ['Recovery', 'Wellness', 'Equipment', 'Gym Accessories', 'Gym'],
    headquarters: 'UK',
    events: ['DAS'],
    email: 'sales@odysseyplunge.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/odyssey_plunge',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/odyssey-plunge/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/odysseyplunge',
      },
    ],
    sponsor: null,
    standNumber: 'G4D',
    standType: 'Space Only',
    website: 'https://odysseyplunge.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '12',
    name: 'MEDX PHARMACY LLC',
    logo: 'https://a.storyblok.com/f/282702/e60fb810f7/20250912105936_medx-pharmacy-llc_cropped.jpg',
    industries: [
      'Nutrition',
      'Pharmacy',
      'Beauty & Wellness',
      'Recovery',
      'Others',
      'Wellness',
      'Technology',
      'Beauty',
      'Supplement Distributor',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'riyas.r@medxpharmacy.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/medxpharmacy/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/medx-pharmacy',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/medxdubai/',
      },
    ],
    sponsor: null,
    standNumber: 'A13',
    standType: 'Brand Only',
    website: 'https://www.medxpharmacy.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '13',
    name: 'TWO PANDAS',
    logo: 'https://a.storyblok.com/f/282702/3bb8f7a6cf/20250915133413_two-pandas-fz-llc_cropped.jpg',
    industries: ['Gym Accessories'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/twopandas.ae',
      },
    ],
    sponsor: null,
    standNumber: 'P3',
    standType: 'Space Only',
    website: 'https://twopandas.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '14',
    name: 'NBPure',
    logo: 'https://a.storyblok.com/f/282702/11dc993203/20250804181511_nutritional-brands-dba_cropped.jpg',
    industries: ['Wellness', 'Beauty & Wellness'],
    headquarters: 'USA',
    events: ['DAS'],
    email: 'Mkt_Admin@nbpure.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/nbpure/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/nbpure',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/NBPure',
      },
    ],
    sponsor: null,
    standNumber: 'G9f',
    standType: 'Brand Only',
    website: 'https://nbpure.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '15',
    name: 'BeneFit Fitness App',
    logo: 'https://a.storyblok.com/f/282702/65df574eb2/20251010080922_benefit-middle-east-llc_cropped.jpg',
    industries: ['Technology', 'Fitness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@benefitapp.me',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/benefit_fitness_app/',
      },
    ],
    sponsor: null,
    standNumber: 'M5',
    standType: 'Space Only',
    website: 'https://www.benefitapp.me/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '16',
    name: 'RUITING SCIENCE AND TECHNOLOGY HEBEI CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/7c2256537f/20251010014147_beijing-worldboson_cropped.jpg',
    industries: ['Fitness', 'Gym Accessories', 'Equipment'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'lola@raetin.com',
    socials: null,
    sponsor: null,
    standNumber: 'F5C-2',
    standType: 'Space Only',
    website: 'https://raetin.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '17',
    name: 'DizzyDuck',
    logo: 'https://a.storyblok.com/f/282702/a7d507de99/20251009092925_dizzy-duck-lab-llp_cropped.jpg',
    industries: ['Apparel', 'Fitness', 'Gym', 'Wellness'],
    headquarters: null,
    events: ['DAS'],
    email: 'info@dizzyduck.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/dizzyduckhq',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/105011079',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/Dizzyduck',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/@dizzyduckhq',
      },
    ],
    sponsor: null,
    standNumber: 'M8',
    standType: 'Space Only',
    website: 'https://dizzyduck.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '18',
    name: 'HUBEI KSHINE PACKAGING CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/17e5af9fcb/20250912095911_beijing-worldboson_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'info@kshine-packaging.com',
    socials: null,
    sponsor: null,
    standNumber: 'C11B-2',
    standType: 'Space Only',
    website: 'https://www.kshine-packaging.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '19',
    name: 'LIFTMEUP WOMEN SPORTS MODEST WEAR',
    logo: 'https://a.storyblok.com/f/282702/849c6f53d0/20250911134159_liftmeup-cloth-trading_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@liftmeup.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/liftmeup.ae/',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/liftmeup.ae',
      },
    ],
    sponsor: null,
    standNumber: 'H5a',
    standType: 'Space Only',
    website: 'https://liftmeup.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '20',
    name: 'Zhejiang Elina Fitness Technology Co., Ltd',
    logo: 'https://a.storyblok.com/f/282702/c68a9144b2/20250905060657_beijing-worldboson_cropped.jpg',
    industries: ['Fitness', 'Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'kelly@elinapilates.cn',
    socials: null,
    sponsor: null,
    standNumber: 'D6A-1',
    standType: 'Space Only',
    website: 'https://www.elinapilates.cn/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '21',
    name: 'Casall',
    logo: 'https://a.storyblok.com/f/282702/26e1a5b2ab/20250911124739_casall-sports-wear-equipment-trading-llc_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Distributor',
      'Recovery',
      'Gym Accessories',
      'Hospitality',
    ],
    headquarters: 'Sweden',
    events: ['DAS'],
    email: 'olga@casallsports.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/casalltraining/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/casalltraining',
      },
    ],
    sponsor: null,
    standNumber: 'H4D',
    standType: 'Space Only',
    website: 'https://www.casall.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '22',
    name: 'Fitx',
    logo: 'https://a.storyblok.com/f/282702/a45c18151b/20251008074233_target-point-software-ltd-_cropped.jpg',
    industries: ['Gym', 'Fitness', 'Technology', 'Gym Accessories'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'naeem@fit-x.app',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fitx_app',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/tpfitx',
      },
    ],
    sponsor: null,
    standNumber: 'L09',
    standType: 'Space Only',
    website: 'https://fit-x.app',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '23',
    name: 'Padel Mi Amor',
    logo: 'https://a.storyblok.com/f/282702/2cea12aed4/20251007132848_padelstyle-srl_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'Italy',
    events: ['DAS'],
    email: 'a.gargani@padelstylesrl.it',
    socials: null,
    sponsor: null,
    standNumber: 'J1B',
    standType: 'Space Only',
    website: 'https://padelmiamor.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '24',
    name: 'Sedona Wellness',
    logo: 'https://a.storyblok.com/f/282702/d81b0769a3/20251007124429_sedona-wellness_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Fitness',
      'Wellness',
      'Recovery',
      'Hospitality',
      'Technology',
    ],
    headquarters: 'USA',
    events: ['DAS'],
    email: 'niki@sedonawellness.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/sedonawellnesspemf',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/sedona-wellness',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/sedonawellnesspemf/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@sedonawellnesspemf',
      },
    ],
    sponsor: null,
    standNumber: 'H1H',
    standType: 'Space Only',
    website: 'https://www.sedonawellness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '25',
    name: 'Meals on Me / 10 x Protein',
    logo: 'https://a.storyblok.com/f/282702/c419a1f13b/20251006125042_meals-on-me-catering-services-llc_cropped.jpg',
    industries: [
      'Hospitality',
      'Others',
      'Nutrition',
      'Supplement Distributor',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/hellomealsonme',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/hello-meals-on-me',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/hellomealsonme/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@hellomealsonme7234',
      },
    ],
    sponsor: null,
    standNumber: 'D5D',
    standType: 'Space Only',
    website: 'https://hellomealsonme.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '26',
    name: 'BUCKED UP',
    logo: 'https://a.storyblok.com/f/282702/393489c29d/20251006144322_das-labs_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Gym',
      'Wellness',
      'Nutrition',
      'Supplement Distributor',
    ],
    headquarters: 'USA',
    events: ['DMS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/buckedup',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/bucked-up',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/Buckedup/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCjheOd3wtIsJqyk_akBbinw',
      },
    ],
    sponsor: null,
    standNumber: 'C12c',
    standType: 'Space Only',
    website: 'https://buckedup.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '27',
    name: 'BEFIT',
    logo: 'https://a.storyblok.com/f/282702/c4e582a454/20250924053657_befit-aki_cropped.jpg',
    industries: [
      'Gym',
      'Hospitality',
      'Equipment',
      'Distributor',
      'Equipment Distributor',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'befitmiddleeast@akigroup.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/befitmiddleeast/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/befitmiddleeast',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/BeFitSportsMe/',
      },
    ],
    sponsor: null,
    standNumber: 'G3a',
    standType: 'Space Only',
    website: 'https://www.befitmiddleeast.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '28',
    name: 'OLIMP',
    logo: 'https://a.storyblok.com/f/282702/27f6420cda/20251003113200_olimp-laboratories_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Fitness',
      'Supplement Distributor',
      'Nutrition',
    ],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'export@olimp-labs.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/olimp_sport_nutrition/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@OlimpSportNutrition',
      },
    ],
    sponsor: null,
    standNumber: 'G11D',
    standType: 'Space Only',
    website: 'https://www.olimpsport.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '29',
    name: 'Bombbar, Chikalab, Snaq Fabriq',
    logo: 'https://a.storyblok.com/f/282702/7c613b39b7/20251002135102_chikalab-food-llc_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Fitness',
      'Gym',
      'Hospitality',
      'Retailer FMCG',
      'Wellness',
      'Nutrition',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'marketing@chikalab.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/bombbar.mena/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@BombbarMENA',
      },
    ],
    sponsor: null,
    standNumber: 'C15',
    standType: 'Space Only',
    website: 'https://www.bombbar.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '30',
    name: 'A.A. Woodfairy',
    logo: 'https://a.storyblok.com/f/282702/850d6a9391/20251002075849_wawi-innovation-gmbh_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'Germany',
    events: ['DAS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'G6b',
    standType: 'Space Only',
    website: 'https://www.aa-woodfairy.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Second batch - new 30 exhibitors
  {
    id: '31',
    name: 'YANGZHOU KAIWEI SPORTING GOODS FACTORY',
    logo: 'https://a.storyblok.com/f/282702/45e8579521/20251002053635_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories', 'Equipment Distributor'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'kaiweisports@vip.163.com',
    socials: null,
    sponsor: null,
    standNumber: 'H1I',
    standType: 'Space Only',
    website: 'https://cntenstarsports.en.alibaba.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '32',
    name: 'MiFitness',
    logo: 'https://a.storyblok.com/f/282702/e80b9e02f0/20251001180536_mifitness_cropped.jpg',
    industries: [
      'Fitness',
      'Gym',
      'Equipment',
      'Wellness',
      'Equipment Distributor',
      'Distributor',
      'Gym Accessories',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'hello@mifitness.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/mifitness_ae/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/mifitnessuae/',
      },
    ],
    sponsor: null,
    standNumber: 'D3a',
    standType: 'Space Only',
    website: 'https://mifitness.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '33',
    name: 'Numod Active',
    logo: 'https://a.storyblok.com/f/282702/3ca1ef2049/20250930160425_numod-active_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'USA',
    events: ['DAS'],
    email: 'sharika.ilyas@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/numod_athleisure/',
      },
    ],
    sponsor: null,
    standNumber: 'G5B',
    standType: 'Space Only',
    website: 'https://www.numodactive.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '34',
    name: 'Inzi',
    logo: 'https://a.storyblok.com/f/282702/01cae37c21/20250930060339_sage-prix-llc-fz-_cropped.jpg',
    industries: ['Fitness', 'Hospitality', 'Nutrition', 'Wellness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'inzieats@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/inzieats/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/in/maria-konovalova-43333554',
      },
    ],
    sponsor: null,
    standNumber: 'P1',
    standType: 'Space Only',
    website: 'https://inzieats.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '35',
    name: 'Padel Factory Middle east',
    logo: 'https://a.storyblok.com/f/282702/ec5b1480dc/20250923112406_cypex-padel-_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Distributor', 'Gym Accessories', 'Beauty'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@padelfactory.me',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/cypex_padelfactory/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/cypex.padel.factory',
      },
    ],
    sponsor: null,
    standNumber: 'J1F',
    standType: 'Space Only',
    website: 'https://padelfactory.me/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '36',
    name: 'Be Lenka',
    logo: 'https://a.storyblok.com/f/282702/829b9af7d0/20251001064431_readymade-garments-trading-llc-co_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Recovery',
      'Distributor',
      'Fitness Franchise',
      'Gym',
      'Wellness',
      'Retailer FMCG',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@belenka.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/belenkaarabia/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCbQ6R9dgocB1Kw-1oD0FB_A',
      },
    ],
    sponsor: null,
    standNumber: 'G8A',
    standType: 'Space Only',
    website: 'https://belenka.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '37',
    name: 'COOLBUILD',
    logo: 'https://a.storyblok.com/f/282702/3127cc1dd5/20250926073130_aquamarine_cropped.jpg',
    industries: [
      'Gym',
      'Gym Accessories',
      'Equipment',
      'Distributor',
      'Equipment Distributor',
    ],
    headquarters: 'China',
    events: ['DMS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'D4',
    standType: 'Space Only',
    website: 'https://www.coolbuildfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '38',
    name: 'POWER FIT',
    logo: 'https://a.storyblok.com/f/282702/56a09998a3/20250925205440_power-fit-trading-llc_cropped.jpg',
    industries: [
      'Fitness',
      'Beauty & Wellness',
      'Wellness',
      'Supplement Distributor',
      'Distributor',
    ],
    headquarters: 'USA',
    events: ['DMS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/powerfitsupps',
      },
    ],
    sponsor: null,
    standNumber: 'B15',
    standType: 'Space Only',
    website: 'https://powerfitsupps.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '39',
    name: 'VIVANDI X CORE NUTRITIONALS',
    logo: 'https://a.storyblok.com/f/282702/7116d5b024/20250925094613_vivandi-general-trading-llc_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'launchpad@vivandidistribution.com',
    socials: null,
    sponsor: null,
    standNumber: 'F8A',
    standType: 'Space Only',
    website: 'https://www.vivandidistribution.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '40',
    name: 'Low Calories',
    logo: 'https://a.storyblok.com/f/282702/20f83f3ae1/20250925091908_low-calories-restaurant_cropped.jpg',
    industries: ['Nutrition', 'Fitness', 'Wellness'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'marketing@lowcalories.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/lowcaloriesae/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/low-calories-restaurant-llc',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/lowcaloriesuae/',
      },
    ],
    sponsor: null,
    standNumber: 'C17',
    standType: 'Space Only',
    website: 'https://lowcalories.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '41',
    name: 'LIFTDEX',
    logo: 'https://a.storyblok.com/f/282702/c87397c933/20250924132033_tradex-llc-_cropped.jpg',
    industries: [
      'Gym',
      'Fitness',
      'Equipment',
      'Gym Accessories',
      'Equipment Distributor',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/Liftdex',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/Liftdex',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/@liftdex4959',
      },
    ],
    sponsor: null,
    standNumber: 'F3',
    standType: 'Space Only',
    website: 'https://liftdex.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '42',
    name: 'MONTIVA.LIFE',
    logo: 'https://a.storyblok.com/f/282702/970773b0cc/20250924082035_aquamarine_cropped.jpg',
    industries: ['Recovery', 'Wellness', 'Fitness'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'sales@montiva.life',
    socials: null,
    sponsor: null,
    standNumber: 'D4',
    standType: 'Space Only',
    website: 'https://www.montiva.life',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '43',
    name: 'Redrex Ramy',
    logo: 'https://a.storyblok.com/f/282702/37ed7e5a84/20250924052333_natures-rule-egypt-llc_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Supplement Distributor'],
    headquarters: 'Egypt',
    events: ['DMS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'A12A',
    standType: 'Space Only',
    website: 'https://bigramylabs.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '44',
    name: 'GLOBAL LINK NUTRITION',
    logo: 'https://a.storyblok.com/f/282702/bbc29d6ec2/20250912105334_global-link-nutrition_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor', 'Distributor'],
    headquarters: 'Australia',
    events: ['DMS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'E8c',
    standType: 'Space Only',
    website: 'https://www.anabolix.com.au/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '45',
    name: 'POKETKEY',
    logo: 'https://a.storyblok.com/f/282702/a9b9f2c1c6/20250923114410_limited-liability-company-poketkey-rus_cropped.jpg',
    industries: ['Equipment Distributor', 'Technology'],
    headquarters: 'Russia',
    events: ['DAI'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'F1A',
    standType: 'Space Only',
    website: 'http://pocketkey.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '46',
    name: 'CORLIV GROUP',
    logo: 'https://a.storyblok.com/f/282702/8dadb42fa9/20250923115654_corliv-products-kft_cropped.jpg',
    industries: ['Nutrition', 'Beauty & Wellness', 'Equipment'],
    headquarters: 'Hungary',
    events: ['DMS'],
    email: 'info@corliv.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/wearecorliv/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/corliv-group/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/corliv/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@corlivgroup/',
      },
    ],
    sponsor: null,
    standNumber: 'D7',
    standType: 'Space Only',
    website: 'https://corliv.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '47',
    name: 'CARBAMIDE FORTE',
    logo: 'https://a.storyblok.com/f/282702/cae113dc91/20250923121530_tsi-global-fzc_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: null,
    events: ['DMS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/carbamideforte/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/carbamide-forte',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/CarbamideForte.mycf',
      },
    ],
    sponsor: null,
    standNumber: 'G10a',
    standType: 'Space Only',
    website: 'https://mycf.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '48',
    name: 'COSMOS PILATES EQUIPMENT',
    logo: 'https://a.storyblok.com/f/282702/43b208fbe8/20250923090213_cosmos-designe-spor-ekipmanlari-mobilya-ithalat-ihracat-sanyi-ve-tic-lt_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Gym Accessories', 'Wellness', 'Equipment'],
    headquarters: 'Turkey',
    events: ['DAI'],
    email: 'info@cosmospilates.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/cosmospilatesequipment',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/107701657',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@cosmospilatesacademy',
      },
    ],
    sponsor: null,
    standNumber: 'F5d',
    standType: 'Space Only',
    website: 'https://Cosmospilates.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '49',
    name: 'ZENSOMA',
    logo: 'https://a.storyblok.com/f/282702/d929058eb0/20250923102410_zensoma-ltd_cropped.jpg',
    industries: [
      'Fitness',
      'Technology',
      'Fitness Franchise',
      'Gym',
      'Nutrition',
      'Wellness',
    ],
    headquarters: null,
    events: ['DAS'],
    email: 'info@zensoma.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/zensoma_fitness/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/in/maha-r-a9b57a27',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/zensoma',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@zensoma',
      },
    ],
    sponsor: null,
    standNumber: 'P5',
    standType: 'Space Only',
    website: 'https://www.zensoma.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '50',
    name: 'C4',
    logo: 'https://a.storyblok.com/f/282702/2e80c64ca7/20250922105108_sport-for-all-general-trading-c4_cropped.jpg',
    industries: ['Supplement Distributor'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'aalnahleh@nutrabolt.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/c4energy_arabia/',
      },
    ],
    sponsor: null,
    standNumber: 'A14A',
    standType: 'Space Only',
    website: 'https://cellucor.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '51',
    name: 'FIERCE ACTIVEWEAR',
    logo: 'https://a.storyblok.com/f/282702/a765c0a937/20250911131033_fierce_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fierceactivewear.mena/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/fiercesportswear/',
      },
    ],
    sponsor: null,
    standNumber: 'J2d',
    standType: 'Space Only',
    website: 'https://www.fierceactivewear.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '52',
    name: 'QANTARA SPORTS',
    logo: 'https://a.storyblok.com/f/282702/c0df09dd2d/20250924041515_qantara-sports-_cropped.jpg',
    industries: [],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@qantarasports.com',
    socials: [
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/qantara-sports/',
      },
    ],
    sponsor: null,
    standNumber: 'F1E',
    standType: 'Space Only',
    website: 'https://www.qantarasports.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '53',
    name: 'Merrithew',
    logo: 'https://a.storyblok.com/f/282702/a4e084fe5c/20250903185937_merrithew_cropped.jpg',
    industries: [
      'Fitness',
      'Distributor',
      'Education & Training',
      'Training Provider',
      'Equipment',
      'Equipment Distributor',
      'Wellness',
    ],
    headquarters: 'Canada',
    events: ['DAI'],
    email: 'equipment@merrithew.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/merrithew/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/merrithew/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/merrithew/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@MERRITHEW',
      },
    ],
    sponsor: null,
    standNumber: 'E4',
    standType: 'Space Only',
    website: 'https://www.merrithew.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '54',
    name: 'Ultra Nutricon Group Kft',
    logo: 'https://a.storyblok.com/f/282702/aa5bf0da9a/20250919113612_ultra-nutricon-group-kft_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'Hungary',
    events: ['DMS'],
    email: 'hello@nutricon24.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/nutricon.24/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/nutricon24',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@UltraNutriconGroup',
      },
    ],
    sponsor: null,
    standNumber: 'F8B',
    standType: 'Space Only',
    website: 'https://nutricon24.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '55',
    name: 'Sky Techsport',
    logo: 'https://a.storyblok.com/f/282702/9c62816596/20250919084827_sky-techsport-inc_cropped.jpg',
    industries: ['Equipment', 'Technology'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/skytechsport_ru',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/c/SkyTechSport',
      },
    ],
    sponsor: null,
    standNumber: 'F3A',
    standType: 'Space Only',
    website: 'https://mideast.skytechsport.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '56',
    name: 'The Fitness Group',
    logo: 'https://a.storyblok.com/f/282702/4eb7ddd33f/20250919074618_the-fitness-group_cropped.jpg',
    industries: ['Education & Training'],
    headquarters: 'UK',
    events: ['DAI'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/thefitnessgrp/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/thefitnessgrp/',
      },
    ],
    sponsor: null,
    standNumber: 'B1',
    standType: 'Space Only',
    website: 'https://www.thefitnessgrp.co.uk/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '57',
    name: 'IRMA FITNESS',
    logo: 'https://a.storyblok.com/f/282702/33218268aa/20250918140108_irma-general-trading-llc_cropped.jpg',
    industries: [
      'Equipment',
      'Fitness Franchise',
      'Gym Accessories',
      'Distributor',
      'Equipment Distributor',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'irma@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/irma_fitness',
      },
    ],
    sponsor: null,
    standNumber: 'C5',
    standType: 'Space Only',
    website: 'https://www.theirmafitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '58',
    name: 'Real Leader',
    logo: 'https://a.storyblok.com/f/282702/49977b9b53/20250919080607_shandong-li-de-fitness-_cropped.jpg',
    industries: ['Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'B6',
    standType: 'Space Only',
    website: 'https://realleadergym.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '59',
    name: 'CORE CHAMPS',
    logo: 'https://a.storyblok.com/f/282702/fe4e0e3d72/20250912114638_jnk_cropped.jpg',
    industries: [
      'Fitness',
      'Distributor',
      'Nutrition',
      'Supplement Distributor',
      'Wellness',
      'Recovery',
      'Beauty & Wellness',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'orders@jnknutrition.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/corechamp',
      },
    ],
    sponsor: null,
    standNumber: 'C14',
    standType: 'Space Only',
    website: 'https://www.corechamps.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '60',
    name: 'Prosupps',
    logo: 'https://a.storyblok.com/f/282702/3d9c037dcd/20250918085251_prosupps-usa-llc_cropped.jpg',
    industries: ['Nutrition', 'Fitness', 'Apparel'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'ccaines@prosupps.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/prosupps/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/prosupps-usa',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/ProSupps/',
      },
      {
        logo: 'youtube',
        link: 'http://www.youtube.com/@ProSuppsTV',
      },
    ],
    sponsor: null,
    standNumber: 'A12B',
    standType: 'Space Only',
    website: 'https://prosupps.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Third batch - new 30 exhibitors (ids 61-90)
  {
    id: '61',
    name: 'Refined Nutrition',
    logo: 'https://a.storyblok.com/f/282702/61c98ed83d/20250917155219_refined-nutrition_cropped.jpg',
    industries: ['Fitness', 'Nutrition'],
    headquarters: 'UK',
    events: ['DMS'],
    email: 'info@refinednutrition.co.uk',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/refinednutrition',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/refined-nutrition/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/refinednutrition/',
      },
    ],
    sponsor: null,
    standNumber: 'C12d',
    standType: 'Space Only',
    website: 'https://www.refinednutrition.co.uk',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '62',
    name: 'Nike Strength',
    logo: 'https://a.storyblok.com/f/282702/8b8a9d356e/20250917085551_andy-enterprises_cropped.jpg',
    industries: ['Distributor', 'Fitness'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/rep.stores/',
      },
    ],
    sponsor: null,
    standNumber: 'C7c',
    standType: 'Space Only',
    website: 'https://rep.store/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '63',
    name: 'CHIBA',
    logo: 'https://a.storyblok.com/f/282702/4b22d2d4c2/20250917121354_chiba-gloves_cropped.jpg',
    industries: ['Gym', 'Fitness', 'Gym Accessories'],
    headquarters: 'Germany',
    events: ['DMS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/chibagloves',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/7341753',
      },
    ],
    sponsor: null,
    standNumber: 'L15',
    standType: 'Space Only',
    website: 'https://www.chiba.de',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '64',
    name: 'Lovinfit Dubai',
    logo: 'https://a.storyblok.com/f/282702/4eb161c413/20250917063150_lovinfit_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Gym',
      'Fitness',
      'Equipment',
      'Beauty',
      'Wellness',
      'Technology',
    ],
    headquarters: 'Italy',
    events: ['DAI'],
    email: 'sales@lovinfitgroup.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/lovinfitgroup/',
      },
    ],
    sponsor: null,
    standNumber: 'B2',
    standType: 'Space Only',
    website: 'https://www.lovinfitgroup.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '65',
    name: 'InBody',
    logo: 'https://a.storyblok.com/f/282702/44edafd610/20250806080035_inbody-co-ltd_cropped.jpg',
    industries: [
      'Distributor',
      'Fitness',
      'Gym',
      'Wellness',
      'Beauty & Wellness',
      'Equipment Distributor',
      'Technology',
      'Equipment',
    ],
    headquarters: null,
    events: ['DAI'],
    email: 'info@inbody.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/inbodymea/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/inbodymea/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/inbodymea/',
      },
    ],
    sponsor: null,
    standNumber: 'F5e',
    standType: 'Space Only',
    website: 'https://mea.inbody.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '66',
    name: 'G & G',
    logo: 'https://a.storyblok.com/f/282702/ae2c14c70b/20250915111053_biotions_cropped.jpg',
    industries: ['Wellness', 'Nutrition'],
    headquarters: 'UK',
    events: ['DAS'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/gandgvits/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/gandgvits/',
      },
    ],
    sponsor: null,
    standNumber: 'J1A',
    standType: 'Space Only',
    website: 'http://www.biotions-uae.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '67',
    name: 'Neutonic',
    logo: 'https://a.storyblok.com/f/282702/23fda90ade/20250915110042_neutonic_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UK',
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/neutonic/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/drinkneutonic/',
      },
    ],
    sponsor: null,
    standNumber: 'E6',
    standType: 'Space Only',
    website: 'https://www.neutonic.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '68',
    name: 'SWEAT',
    logo: 'https://a.storyblok.com/f/282702/d51e62b6c0/20250915103949_sweat_cropped.jpg',
    industries: ['Fitness', 'Technology'],
    headquarters: 'Australia',
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/sweat/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/sweatco/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/Sweat/',
      },
    ],
    sponsor: null,
    standNumber: '',
    standType: 'Space Only',
    website: 'https://sweat.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '69',
    name: 'FUEL UP',
    logo: 'https://a.storyblok.com/f/282702/be726e4fc7/20250915122605_dm-group-sp-z-o-o-sp-k_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'international@fuel-up.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fuel_up_vitamins_official',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/fuelup.official',
      },
    ],
    sponsor: null,
    standNumber: 'B12a',
    standType: 'Space Only',
    website: 'https://www.fuel-up.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '70',
    name: 'BLUEWATER',
    logo: 'https://a.storyblok.com/f/282702/58d0463f8f/20250917080852_nia-general-trading-_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Education & Training',
      'Fitness',
      'Gym',
      'Hospitality',
      'Wellness',
      'Technology',
      'Gym Accessories',
      'Fitness Franchise',
      'Equipment',
      'Others',
      'Equipment Distributor',
      'Distributor',
      'Nutrition',
    ],
    headquarters: 'Sweden',
    events: ['DAS'],
    email: 'rohith@nia.me',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/bluewaterglobe',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/bluewaterpure/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/BluewaterGlobe',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@BluewaterSe',
      },
    ],
    sponsor: 'Sustainability Partner',
    standNumber: 'H9B',
    standType: 'Space Only',
    website: 'https://bluewatergroup.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '71',
    name: 'WISEWELL TRADING LLC',
    logo: 'https://a.storyblok.com/f/282702/3ab1a89dca/20250915131301_wisewell-trading-llc_cropped.jpg',
    industries: ['Technology', 'Wellness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'support@wisewell.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/wisewell.ae/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/wisewellwater',
      },
    ],
    sponsor: null,
    standNumber: 'H3f',
    standType: 'Space Only',
    website: 'http://wisewell.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '72',
    name: 'ATHLECULT',
    logo: 'https://a.storyblok.com/f/282702/8408b623fa/20250915124333_athlecult-sport-equipment-trading-co-llc_cropped.jpg',
    industries: ['Equipment'],
    headquarters: 'Spain',
    events: ['DAI'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/athlecult/',
      },
    ],
    sponsor: null,
    standNumber: 'G1',
    standType: 'Space Only',
    website: 'https://www.athlecult.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '73',
    name: 'HON FOODS LLC',
    logo: 'https://a.storyblok.com/f/282702/c90edfd495/20250915113547_happiness-of-nutrition-hon-foods-llc_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'me@honfoods.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/honfoodsglobal',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/honfoodsglobal',
      },
    ],
    sponsor: null,
    standNumber: 'P6',
    standType: 'Space Only',
    website: 'https://www.honfoods.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '74',
    name: 'DHZ Fitness',
    logo: 'https://a.storyblok.com/f/282702/0a01d3e16b/20250918030007_dhz-fitness-europe-gmbh_cropped.jpg',
    industries: [
      'Equipment Distributor',
      'Equipment',
      'Distributor',
      'Fitness',
      'Gym',
      'Wellness',
    ],
    headquarters: 'China',
    events: ['DAI'],
    email: 'sales@dhzfitness.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/dhz.fitness.chn/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/dhz-fitness/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/dhzchina',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@dhzfitnesschn',
      },
    ],
    sponsor: null,
    standNumber: 'C4',
    standType: 'Space Only',
    website: 'https://www.dhzfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '75',
    name: 'VALENTIERE',
    logo: 'https://a.storyblok.com/f/282702/33f0388781/20250915132833_valentiere-co_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'C10c',
    standType: 'Space Only',
    website: 'https://valentiere.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '76',
    name: 'Creapure',
    logo: 'https://a.storyblok.com/f/282702/6344f280dd/20250718094335_core-velocity-sport-machine-trading-llc_cropped.jpg',
    industries: ['Supplement Distributor'],
    headquarters: 'Germany',
    events: ['DMS'],
    email: 'info@aspnleaf.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/creapure',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/@creapure',
      },
    ],
    sponsor: null,
    standNumber: 'C11b-1',
    standType: 'Space Only',
    website: 'https://creapure.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '77',
    name: 'ANYTIME FITNESS UAE',
    logo: 'https://a.storyblok.com/f/282702/d1fce6b99e/20250914095112_purple-fitness-llc_cropped.jpg',
    industries: [
      'Gym',
      'Fitness',
      'Education & Training',
      'Fitness Franchise',
      'Wellness',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@anytimefitness.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/anytimefitness_arjan',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/anytime-fitness-uae/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/anytimefitness.arjan/',
      },
    ],
    sponsor: null,
    standNumber: 'H1A',
    standType: 'Space Only',
    website: 'https://www.anytimefitness.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '78',
    name: 'Andy Enterprises',
    logo: 'https://a.storyblok.com/f/282702/d0ecc33ecf/20250915134807_andy-enterprises_cropped.jpg',
    industries: ['Distributor'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'C7c',
    standType: 'Space Only',
    website: 'https://www.andy.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '79',
    name: 'MYTICOS',
    logo: 'https://a.storyblok.com/f/282702/be39686739/20250910124034_myt-commerce-llc_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Gym',
      'Gym Accessories',
      'Wellness',
      'Nutrition',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'admin@myticos.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/myticosyou/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/people/Myticos/61563106183133',
      },
    ],
    sponsor: null,
    standNumber: 'H5c',
    standType: 'Space Only',
    website: 'https://www.myticos.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '80',
    name: 'LUX AETERNA CLINIC',
    logo: 'https://a.storyblok.com/f/282702/3a39c7522c/20250911135155_lux-aeterna-medical-center-dmcc_cropped.jpg',
    industries: ['Recovery', 'Nutrition', 'Beauty & Wellness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@luxaeterna.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/luxaeterna.ae',
      },
    ],
    sponsor: null,
    standNumber: 'C10A',
    standType: 'Space Only',
    website: 'https://luxaeterna.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '81',
    name: 'IFPE Academy',
    logo: 'https://a.storyblok.com/f/282702/919c11cd20/20250903214043_ifpe-academy_cropped.jpg',
    industries: [
      'Education & Training',
      'Fitness',
      '⁠Association or Council',
      'Fitness Franchise',
      'Distributor',
      'Training Provider',
      'Equipment Distributor',
      'Wellness',
      'Supplement Distributor',
      'Recovery',
      'Gym',
    ],
    headquarters: 'UAE',
    events: ['DMS', 'DAI'],
    email: 'info@ifpe-academy.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/ifpe_academy/',
      },
    ],
    sponsor: null,
    standNumber: 'L3',
    standType: 'Space Only',
    website: 'https://www.ifpe-academy.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '82',
    name: 'THE SOAP BOX',
    logo: 'https://a.storyblok.com/f/282702/8b4a589562/20250720132911_the-kuwait-irish-company-for-imports-and-distribution_cropped.jpg',
    industries: ['Beauty', 'Beauty & Wellness'],
    headquarters: 'Kuwait',
    events: ['DAS'],
    email: 'info@thesoapboxkuwait.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/thesoapboxkuwait/',
      },
    ],
    sponsor: null,
    standNumber: 'H2d',
    standType: 'Space Only',
    website: 'https://thesoapboxkuwait.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '83',
    name: 'HUMBLE POWER',
    logo: 'https://a.storyblok.com/f/282702/6818740df0/20250912102621_humble-group_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@humblepower.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/humblepower.ae/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/humblepowershop/',
      },
    ],
    sponsor: null,
    standNumber: 'G8A',
    standType: 'Space Only',
    website: 'https://www.humblepower.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '84',
    name: 'DINGZHOU ZHONGTENGSUBO SPORTING GOODS CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/530b375f14/20250905024307_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Fitness', 'Gym Accessories'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'jackson@ztsbsport.com',
    socials: null,
    sponsor: null,
    standNumber: 'G6A',
    standType: 'Space Only',
    website: 'https://www.toptonssport.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '85',
    name: 'ELITE ATHLETE',
    logo: 'https://a.storyblok.com/f/282702/1f4ae78b74/20250826092036_elite-athlete-middle-east-llc_cropped.jpg',
    industries: [
      'Equipment Distributor',
      'Equipment',
      'Distributor',
      'Fitness',
      'Gym',
      'Gym Accessories',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'asif@eliteathlete.ae',
    socials: null,
    sponsor: null,
    standNumber: 'F7A',
    standType: 'Space Only',
    website: 'https://eliteathlete.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '86',
    name: 'VISBODY',
    logo: 'https://a.storyblok.com/f/282702/a410c1bd7b/20250811113510_beauty-leaders-ltd_cropped.jpg',
    industries: [
      'Distributor',
      'Beauty',
      'Equipment',
      'Gym',
      'Beauty & Wellness',
      'Equipment Distributor',
      'Wellness',
      'Hospitality',
      'Fitness',
    ],
    headquarters: 'USA',
    events: ['DAI', 'DAS'],
    email: 'khader@beautyleaders.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/visbody_official/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/visbody/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/Visbody/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCxRg0lnj4bWCMtuoiNJWXyw',
      },
    ],
    sponsor: null,
    standNumber: 'L5',
    standType: 'Space Only',
    website: 'https://visbody.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '87',
    name: 'SENTINEL FITNESS',
    logo: 'https://a.storyblok.com/f/282702/e0d105134b/20250912065813_sentinel-fitness_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Technology', 'Wellness'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@sentinelscope.com',
    socials: [
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/scope-software-solutions-llc',
      },
    ],
    sponsor: null,
    standNumber: 'H1g',
    standType: 'Space Only',
    website: 'https://www.scopesoftware.co.uk',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '88',
    name: 'OXYENERGY',
    logo: 'https://a.storyblok.com/f/282702/4ba1e541fb/20250822063656_ding-yi-nutrition-limited_cropped.jpg',
    industries: [
      'Pharmacy',
      'Fitness',
      'Technology',
      'Beauty',
      'Gym',
      'Nutrition',
      'Wellness',
      'Beauty & Wellness',
      'Supplement Distributor',
      'Recovery',
      'Others',
    ],
    headquarters: 'New Zealand',
    events: ['DAS', 'DMS'],
    email: 'Patrick@oxyenergy-labs.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/oxyenergynz/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/in/patrick-lee-bb106b2b9',
      },
    ],
    sponsor: null,
    standNumber: 'G10B',
    standType: 'Space Only',
    website: 'https://oxyenergy.co.nz/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '89',
    name: 'Nänosupps',
    logo: 'https://a.storyblok.com/f/282702/573f912d8a/20250822075332_next-level-foods-fzco_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'Hungary',
    events: ['DMS'],
    email: 'hello@nanosupps.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/nanosupps/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/nanosupps',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/nanosupps/',
      },
    ],
    sponsor: null,
    standNumber: 'E8b',
    standType: 'Space Only',
    website: 'https://www.nanosupps.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '90',
    name: 'Applied Nutrition PLC',
    logo: 'https://a.storyblok.com/f/282702/0d369aa7f6/20250912112410_applied-nutrition_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UK',
    events: ['DMS'],
    email: 'shaun.mangan@appliednutrition.uk',
    socials: null,
    sponsor: null,
    standNumber: 'H14, H14a, H14b',
    standType: 'Space Only',
    website: 'https://www.appliednutrition.uk',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Fourth batch - new 40 exhibitors (ids 91-130)
  {
    id: '91',
    name: 'Huizhou Zhouxiang Plastic Technology Co,. Ltd',
    logo: 'https://a.storyblok.com/f/282702/c11fbea502/20250912092535_beijing-worldboson_cropped.jpg',
    industries: ['Fitness', 'Equipment', 'Retailer FMCG'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'tropicalswim@126.com',
    socials: null,
    sponsor: null,
    standNumber: 'H1J',
    standType: 'Space Only',
    website: 'http://XXXXXXXX.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '92',
    name: 'BAODING WOOSUNG SPORTS GOODS CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/df9da7776a/20250912091851_beijing-worldboson_cropped.jpg',
    industries: ['Others'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'bella@woosungsports.cn',
    socials: null,
    sponsor: null,
    standNumber: 'D6C-1',
    standType: 'Space Only',
    website: 'https://www.youxingsports.com.cn',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '93',
    name: 'Changzhou Jinyou New Material Technology Co., Ltd.',
    logo: 'https://a.storyblok.com/f/282702/e3f48b3807/20250912091814_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Gym Accessories'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'cindy@jinyoumaterial.com',
    socials: null,
    sponsor: null,
    standNumber: 'L6',
    standType: 'Space Only',
    website: 'http://www.czjynmt.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '94',
    name: 'TAIWAN SUPPORTER CORP.',
    logo: 'https://a.storyblok.com/f/282702/a6e357b393/20250912090609_beijing-worldboson_cropped.jpg',
    industries: ['Equipment'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'catherine@tsportchina.com',
    socials: null,
    sponsor: null,
    standNumber: 'H4A',
    standType: 'Space Only',
    website: 'https://tsport.en.alibaba.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '95',
    name: 'Kaimun',
    logo: 'https://a.storyblok.com/f/282702/0f641c29fd/20250912085001_line-of-purpose-general-trading-llc_cropped.jpg',
    industries: ['Nutrition', 'Fitness'],
    headquarters: 'Switzerland',
    events: ['DMS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/kaimun_food',
      },
    ],
    sponsor: null,
    standNumber: 'L19B',
    standType: 'Space Only',
    website: 'https://www.lineofpurpose.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '96',
    name: 'RIZHAO PIONEER BARBELL & FITNESS INC.',
    logo: 'https://a.storyblok.com/f/282702/031e4dc019/20250912085232_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Gym Accessories'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'april@ironbullfitness.com',
    socials: null,
    sponsor: null,
    standNumber: 'L11',
    standType: 'Space Only',
    website: 'https://www.ironbullfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '97',
    name: 'Jiangsu Top Machinery Co.,LTD.',
    logo: 'https://a.storyblok.com/f/282702/ce5063f765/20250912084147_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories', 'Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'info@jintuofitness.com',
    socials: null,
    sponsor: null,
    standNumber: 'L12',
    standType: 'Space Only',
    website: 'https://www.jintuofitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '98',
    name: 'SPARTANS BOXING CLUB',
    logo: 'https://a.storyblok.com/f/282702/ee6eeb2bc2/20250912083351_sbc-middle-east-investments-llc_cropped.jpg',
    industries: ['Fitness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'community@spartansboxing.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/boxingspartans/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/spartansboxingclub/',
      },
    ],
    sponsor: null,
    standNumber: 'H3d',
    standType: 'Space Only',
    website: 'https://spartansboxing.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '99',
    name: 'TIANJIN KONBEST TECHNOLOGY CO., LTD',
    logo: 'https://a.storyblok.com/f/282702/c0ee89c8ee/20250912081409_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Recovery', 'Wellness'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'sales@tjkonbest.com',
    socials: null,
    sponsor: null,
    standNumber: 'L13',
    standType: 'Space Only',
    website: 'https://konbest.co/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '100',
    name: 'JiangSu Leeton Machinery Co.,Ltd.',
    logo: 'https://a.storyblok.com/f/282702/4d7a7c4a29/20250912073607_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'cash@leetonfitness.com',
    socials: null,
    sponsor: null,
    standNumber: 'L4',
    standType: 'Space Only',
    website: 'https://www.leetonfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '101',
    name: 'BELENKA',
    logo: 'https://a.storyblok.com/f/282702/ce9785e5e4/20250912071518_humble-group_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@belenka.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/belenkaarabia/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCbQ6R9dgocB1Kw-1oD0FB_A',
      },
    ],
    sponsor: null,
    standNumber: 'G8A',
    standType: 'Space Only',
    website: 'https://belenka.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '102',
    name: 'Hebei Kangnayipin SportingEquipment Co., Ltd.',
    logo: 'https://a.storyblok.com/f/282702/36e2e9a224/20250912071407_beijing-worldboson_cropped.jpg',
    industries: ['Beauty & Wellness', 'Recovery', 'Wellness'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'info@knypsports.com',
    socials: null,
    sponsor: null,
    standNumber: 'C10E',
    standType: 'Space Only',
    website: 'https://www.knypsports.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '103',
    name: 'SEISSENSE',
    logo: 'https://a.storyblok.com/f/282702/b5774f2114/20250912074818_seissense_cropped.jpg',
    industries: ['Apparel'],
    headquarters: null,
    events: ['DAS'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/weareseissense/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/seissense/',
      },
    ],
    sponsor: 'Platinum Sponsor',
    standNumber: 'D5A',
    standType: 'Space Only',
    website: 'https://seissense.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '104',
    name: 'SHANXI A&R INDUSTRIAL TRADE CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/c3e8e23d90/20250912071108_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'zjfsipc@anhong-sports.com',
    socials: null,
    sponsor: null,
    standNumber: 'C10F',
    standType: 'Space Only',
    website: 'http://www.anhong-sports.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '105',
    name: 'Nantong July Fitness&Sports Co.,Ltd.',
    logo: 'https://a.storyblok.com/f/282702/29c10e57c4/20250912070847_beijing-worldboson_cropped.jpg',
    industries: ['Distributor', 'Fitness', 'Recovery'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'fionalee@july-sports.com',
    socials: null,
    sponsor: null,
    standNumber: 'C10D',
    standType: 'Space Only',
    website: 'https://www.july-sports.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '106',
    name: 'Nantong TeamForce Sports Co.,Ltd.',
    logo: 'https://a.storyblok.com/f/282702/61955e6c0d/20250912070503_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'julia@teamforcefit.com',
    socials: null,
    sponsor: null,
    standNumber: 'L8',
    standType: 'Space Only',
    website: 'https://www.teamforcefit.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '107',
    name: 'Qingdao Great Century Plastic Co.,Ltd',
    logo: 'https://a.storyblok.com/f/282702/e16ef11c41/20250912070201_beijing-worldboson_cropped.jpg',
    industries: ['Fitness', 'Gym Accessories', 'Distributor'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'gc.international@qdgreatsafety.com',
    socials: null,
    sponsor: null,
    standNumber: 'C10B',
    standType: 'Space Only',
    website: 'https://qdgreatsafety.en.alibaba.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '108',
    name: 'SHANDONG MINOLTA FITNESS EQUIPMENT CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/e946627b15/20250912065307_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Fitness'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'mnd002@mndfit.com',
    socials: null,
    sponsor: null,
    standNumber: 'B7A-4',
    standType: 'Space Only',
    website: 'https://www.mndfitness.com.cn',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '109',
    name: 'SHANDONG LIMEIXING FITNESS EQUIPMENT CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/9f3c8d8b20/20250912064840_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Fitness'],
    headquarters: 'China',
    events: ['DAI'],
    email: '13792200000@163.com',
    socials: null,
    sponsor: null,
    standNumber: 'B7A-3',
    standType: 'Space Only',
    website: 'https://www.limeixing.cn/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '110',
    name: 'QINGDAO SAMWHA SPORTS GOODS CO., LTD',
    logo: 'https://a.storyblok.com/f/282702/f46f95feb1/20250912064507_beijing-worldboson_cropped.jpg',
    industries: [
      'Education & Training',
      'Gym Accessories',
      'Training Provider',
    ],
    headquarters: 'China',
    events: ['DAI'],
    email: 'guozhenyu@sh-sports.cn',
    socials: null,
    sponsor: null,
    standNumber: 'B7A-2',
    standType: 'Space Only',
    website: 'https://www.sh-sports.cn',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '111',
    name: 'AQUAME',
    logo: 'https://a.storyblok.com/f/282702/a2977e84aa/20250912061343_aquame_cropped.jpg',
    industries: ['Technology', 'Wellness', 'Recovery', 'Fitness'],
    headquarters: 'Australia',
    events: ['DAS'],
    email: 'info@aquame.co',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/aquamesports',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/aquame/',
      },
    ],
    sponsor: null,
    standNumber: 'J3A',
    standType: 'Space Only',
    website: 'https://www.aquame.co',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '112',
    name: 'Nantong OK Sporting Co.,Ltd',
    logo: 'https://a.storyblok.com/f/282702/8d9edbdf98/20250911153345_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories', 'Fitness'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'davin@oksporting.com',
    socials: null,
    sponsor: null,
    standNumber: 'B5-4',
    standType: 'Space Only',
    website: 'https://www.oksporting.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '113',
    name: 'SHANDONG JINGGONG FITNESS EQUIPMENT CO., LTD.',
    logo: 'https://a.storyblok.com/f/282702/c1d962228a/20250911152129_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Equipment Distributor'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'brooks@jinggongfitness.com',
    socials: null,
    sponsor: null,
    standNumber: 'B5-3',
    standType: 'Space Only',
    website: 'https://www.jingonfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '114',
    name: 'NANTONG MODERN SPORTING INDUSTRIAL CO.,LTD.',
    logo: 'https://a.storyblok.com/f/282702/15f5cfe047/20250911151059_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Gym Accessories', 'Fitness'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'aaronx@modernsporting.com',
    socials: null,
    sponsor: null,
    standNumber: 'B5-1',
    standType: 'Space Only',
    website: 'https://www.china-sport.cn',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '115',
    name: 'HUSTLERS ONLY',
    logo: 'https://a.storyblok.com/f/282702/b8772e84f6/20250911133319_j-arthur-limited-_cropped.jpg',
    industries: ['Apparel', 'Gym Accessories'],
    headquarters: 'UK',
    events: ['DAS'],
    email: 'info@hustlersonlypk.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/HustlersOnly.PK',
      },
    ],
    sponsor: null,
    standNumber: 'B12C',
    standType: 'Space Only',
    website: 'https://hustlersonlyuae.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '116',
    name: 'SHANDONG AOLEST FITNESS EQUIPMENT CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/a1e9c82a50/20250911150527_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Equipment Distributor', 'Fitness'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'staff1@yftrade.com.cn',
    socials: null,
    sponsor: null,
    standNumber: 'B4-3',
    standType: 'Space Only',
    website: 'https://www.aolestfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '117',
    name: 'NALA DUBAI',
    logo: 'https://a.storyblok.com/f/282702/0dad96173d/20250911142700_nala-readymade-garments-trading-llc_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'info@naladubai.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/nala.global/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/Nala.DubaiGobal',
      },
    ],
    sponsor: null,
    standNumber: 'H3e',
    standType: 'Space Only',
    website: 'https://nala.global/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '118',
    name: 'Cahva Creamer',
    logo: 'https://a.storyblok.com/f/282702/feb46807f7/20250911121323_cahva-trading-llc_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/cahvacreamer.uae',
      },
    ],
    sponsor: null,
    standNumber: 'H8C',
    standType: 'Space Only',
    website: 'https://mycahvauae.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '119',
    name: 'G8TS',
    logo: 'https://a.storyblok.com/f/282702/bac8ecad03/20250911115533_gats-technology_cropped.jpg',
    industries: ['Technology', 'Fitness'],
    headquarters: null,
    events: ['DAS'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/g8tsclub/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/g8tsclub/',
      },
    ],
    sponsor: 'App / Wristband Partner',
    standNumber: 'G7A',
    standType: 'Space Only',
    website: 'https://g8ts.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '120',
    name: 'SHANGHAI EASTERN YANRE FITNESS EQUIPMENT CO.,LTD',
    logo: 'https://a.storyblok.com/f/282702/7d5ddd9804/20250911103307_beijing-worldboson_cropped.jpg',
    industries: ['Equipment', 'Fitness', 'Equipment Distributor'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'echo@yanrefitness.com',
    socials: null,
    sponsor: null,
    standNumber: 'B4-1',
    standType: 'Space Only',
    website: 'https://www.yanrefitness.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '121',
    name: 'Barebells',
    logo: 'https://a.storyblok.com/f/282702/c5ac8c7532/20250911085102_champions-food-beverages-trading_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor'],
    headquarters: 'Sweden',
    events: ['DMS'],
    email: 'osamaelhaggar@championsdxb.net',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/barebellsuae/',
      },
    ],
    sponsor: null,
    standNumber: 'G12b',
    standType: 'Space Only',
    website: 'https://barebells.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '122',
    name: 'RIGHT DOSE',
    logo: 'https://a.storyblok.com/f/282702/fd0822859f/20250909133615_right-dose-dietary-supps_cropped.jpg',
    industries: [
      'Fitness',
      'Distributor',
      'Nutrition',
      'Supplement Distributor',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'info@rightdose.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/right_dose_supplements/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/rightdose22/',
      },
    ],
    sponsor: null,
    standNumber: 'A11',
    standType: 'Space Only',
    website: 'https://rightdose.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '123',
    name: 'Shandong Shuyou Te Fitness Technology Co., Ltd',
    logo: 'https://a.storyblok.com/f/282702/40e260a756/20250909080003_beijing-worldboson_cropped.jpg',
    industries: ['Fitness', 'Gym Accessories', 'Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: '273296668@qq.com',
    socials: null,
    sponsor: null,
    standNumber: 'A5-4',
    standType: 'Space Only',
    website: 'http://zh.zffitness.cn/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '124',
    name: 'Shandong Langmai Fitness Equipment Co., Ltd.',
    logo: 'https://a.storyblok.com/f/282702/133fea612f/20250909074924_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories', 'Fitness', 'Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: '2738885689@qq.com',
    socials: null,
    sponsor: null,
    standNumber: 'A5-3',
    standType: 'Space Only',
    website: 'HTTPS://LMFITNESS.EN.ALIBABA.COM',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '125',
    name: 'WELLNESSWONDERZ',
    logo: 'https://a.storyblok.com/f/282702/465ac94433/20250909061105_wonderz-of-wellness-fz-llc_cropped.jpg',
    industries: ['Apparel', 'Fitness', 'Wellness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'hello@wellnesswonderz.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/wellnesswonderzme/',
      },
    ],
    sponsor: null,
    standNumber: 'H3a',
    standType: 'Space Only',
    website: 'https://wellnesswonderz.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '126',
    name: 'REPZERO BY RIANG.',
    logo: 'https://a.storyblok.com/f/282702/51a6654c1b/20250908120358_riang-ecommerce-fzco_cropped.jpg',
    industries: [
      'Apparel',
      'Gym',
      'Fitness',
      'Education & Training',
      'Wellness',
      'Recovery',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: '',
    socials: [],
    sponsor: 'Gold Sponsor',
    standNumber: 'H4B',
    standType: 'Space Only',
    website: 'https://www.repzerobyriang.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '127',
    name: 'Xiamen Renhe Import and Export Trade',
    logo: 'https://a.storyblok.com/f/282702/373943cf65/20250905022907_beijing-worldboson_cropped.jpg',
    industries: ['Fitness', 'Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: 'candy@renhesports.com',
    socials: null,
    sponsor: null,
    standNumber: 'B4-2',
    standType: 'Space Only',
    website: 'https://www.renhesports.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '128',
    name: 'EUROVO',
    logo: 'https://a.storyblok.com/f/282702/ea1f30d30f/20250904134652_eurovo-srl_cropped.jpg',
    industries: ['Nutrition', 'Gym', 'Fitness'],
    headquarters: 'Italy',
    events: ['DMS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'B12b',
    standType: 'Space Only',
    website: 'https://www.eurovo.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '129',
    name: 'USN',
    logo: 'https://a.storyblok.com/f/282702/c49ce54204/20250904131133_usn-uk_cropped.jpg',
    industries: [
      'Gym Accessories',
      'Wellness',
      'Recovery',
      'Beauty & Wellness',
      'Education & Training',
      'Fitness',
      'Gym',
      'Nutrition',
    ],
    headquarters: 'South Africa',
    events: ['DMS'],
    email: 'mp@usn.co.uk',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/usnsa',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/ultimate-sport-nutrition-usn-',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/USNSA',
      },
    ],
    sponsor: null,
    standNumber: 'F7c',
    standType: 'Space Only',
    website: 'https://www.usn.global',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '130',
    name: 'JERAI FITNESS',
    logo: 'https://a.storyblok.com/f/282702/c9f4ee67a8/20250904105028_new-extreme-sports_cropped.jpg',
    industries: [
      'Fitness',
      'Gym',
      'Equipment',
      'Fitness Franchise',
      'Gym Accessories',
      'Nutrition',
      'Supplement Distributor',
      'Equipment Distributor',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'B8',
    standType: 'Space Only',
    website: 'https://www.extremesportstrading.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Sixth batch - new 21 exhibitors (ids 161-181)
  {
    id: '161',
    name: 'VM Group',
    logo: 'https://a.storyblok.com/f/282702/8141351bc9/20250904095912_vm-group-rtf-llc-_cropped.jpg',
    industries: ['Beauty & Wellness', 'Fitness', 'Nutrition', 'Wellness'],
    headquarters: 'Russia',
    events: ['DMS'],
    email: null,
    socials: null,
    sponsor: null,
    standNumber: 'E7B',
    standType: 'Space Only',
    website: 'https://vmgroupp.ru',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '162',
    name: 'RESTORE',
    logo: 'https://a.storyblok.com/f/282702/1b5a39e816/20250904094004_restore-fze_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Fitness',
      'Recovery',
      'Wellness',
      'Beauty',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'contact@restorefitness.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/restorefitness.ae/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/in/restore-fitness/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/Restorefitnesss/',
      },
    ],
    sponsor: null,
    standNumber: 'H5E',
    standType: 'Space Only',
    website: 'https://restorefitness.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '163',
    name: 'ACTIVLAB',
    logo: 'https://a.storyblok.com/f/282702/63f4a1f5eb/20250904084722_kmaxx-sports-nutrition_cropped.jpg',
    industries: [
      'Supplement Distributor',
      'Nutrition',
      'Distributor',
      'Fitness',
      'Education & Training',
      'Beauty & Wellness',
      'Gym',
      'Recovery',
      'Wellness',
      'Beauty',
      'Pharmacy',
    ],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'export.ismd@activlab.pl',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/activlab_official_world/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/26534547',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/ActivlabPoland',
      },
    ],
    sponsor: null,
    standNumber: 'C13',
    standType: 'Space Only',
    website: 'https://www.b2b.activlab.pl/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '164',
    name: 'Wuhu Fly Bear Import And Export Trade Co., Ltd',
    logo: 'https://a.storyblok.com/f/282702/92f3b2a87e/20250904061314_beijing-worldboson_cropped.jpg',
    industries: ['Fitness'],
    headquarters: 'China',
    events: ['DAS'],
    email: '19773857@qq.com',
    socials: null,
    sponsor: null,
    standNumber: 'C11B-3, C11B-4, L14',
    standType: 'Space Only',
    website: 'https://whfeixiong.en.alibaba.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '165',
    name: 'MacroActive',
    logo: 'https://a.storyblok.com/f/282702/ea5e3e3d75/20250904014517_macroactive_cropped.jpg',
    industries: ['Education & Training', 'Fitness', 'Technology', 'Media'],
    headquarters: 'New Zealand',
    events: ['DAS', 'DAI'],
    email: 'ken@macroactive.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/macroactive',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/c/MacroActive',
      },
    ],
    sponsor: null,
    standNumber: 'F6a',
    standType: 'Space Only',
    website: 'https://www.macroactive.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '166',
    name: 'RABFIT',
    logo: 'https://a.storyblok.com/f/282702/949884e0f0/20250903101011_rabfit-trading-llc-_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'Hello@rabfit.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/rabfitwear',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/rabfitwear',
      },
    ],
    sponsor: null,
    standNumber: 'J3A',
    standType: 'Space Only',
    website: 'https://www.Rabfit.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '167',
    name: 'Qodeca',
    logo: 'https://a.storyblok.com/f/282702/76d8c35cfc/20250827082618_qodeca-sp-z-o-o-_cropped.jpg',
    industries: [
      'Fitness Franchise',
      'Gym',
      'Training Provider',
      'Education & Training',
      'Fitness',
      'Equipment',
      'Gym Accessories',
      'Equipment Distributor',
      'Technology',
    ],
    headquarters: 'Poland',
    events: ['DAI'],
    email: 'hi@codeca.com',
    socials: [
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/qodecasoftwaredevelopment/',
      },
    ],
    sponsor: "Buyer's Lounge Sponsor",
    standNumber: '',
    standType: 'Space Only',
    website: 'https://www.qodeca.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '168',
    name: 'Z-Smell',
    logo: 'https://a.storyblok.com/f/282702/14daa24fed/20250903074436_cheongsoo-e-s-inc_cropped.jpg',
    industries: [
      'Others',
      'Gym Accessories',
      'Retailer FMCG',
      'Wellness',
      'Technology',
    ],
    headquarters: null,
    events: ['DAS'],
    email: 'crystalrbusy@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/zsmellofficial/',
      },
    ],
    sponsor: null,
    standNumber: 'G9g',
    standType: 'Space Only',
    website: 'https://tryzerosmell.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '169',
    name: 'BioTechUSA',
    logo: 'https://a.storyblok.com/f/282702/cc266f5831/20250721123955_biotechusa_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Beauty & Wellness',
      'Others',
      'Supplement Distributor',
      'Nutrition',
    ],
    headquarters: 'Hungary',
    events: ['DMS'],
    email: 'info@biotechusa.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/biotechusa',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/biotechusa',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/biotechusa.hu/',
      },
    ],
    sponsor: null,
    standNumber: 'E9',
    standType: 'Space Only',
    website: 'https://biotechusa.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '170',
    name: 'Qingdao Krypton International Trade Co.,Ltd',
    logo: 'https://a.storyblok.com/f/282702/b041f87e83/20250903034027_beijing-worldboson_cropped.jpg',
    industries: ['Gym Accessories', 'Equipment'],
    headquarters: 'China',
    events: ['DAS'],
    email: 'info@krypton-fitness.com',
    socials: null,
    sponsor: null,
    standNumber: 'A9C',
    standType: 'Space Only',
    website: 'https://www.krypton-fitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '171',
    name: 'ANIMAL',
    logo: 'https://a.storyblok.com/f/282702/1d3ee34e9b/20250902175844_universal-protein-supplements-corp_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'info@animalpak.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/animalpak/',
      },
    ],
    sponsor: null,
    standNumber: 'G11b',
    standType: 'Space Only',
    website: 'https://www.animalpak.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '172',
    name: 'Red One Nutrition',
    logo: 'https://a.storyblok.com/f/282702/c17444bd2b/20250902131448_redone_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'UK',
    events: ['DMS'],
    email: 'engineers.best@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/redonenutritions',
      },
    ],
    sponsor: null,
    standNumber: 'F8c',
    standType: 'Space Only',
    website: 'https://www.redonenutrition.net',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '173',
    name: 'TORO',
    logo: 'https://a.storyblok.com/f/282702/b684c70e12/20250902121029_urban-fitness-cart-sport-equipment-trading-llc_cropped.jpg',
    industries: [
      'Distributor',
      'Fitness',
      'Gym',
      'Equipment',
      'Equipment Distributor',
      'Gym Accessories',
    ],
    headquarters: 'UK',
    events: ['DAI'],
    email: 'info@torofitness.uk',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/torofitness.uk',
      },
    ],
    sponsor: null,
    standNumber: 'C7B',
    standType: 'Space Only',
    website: 'https://torofitness.uk/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '174',
    name: 'BIG SAM',
    logo: 'https://a.storyblok.com/f/282702/7e72a59f62/20250902111213_ilya-tekstil-ve-insaat-sanayi-ticaret-limited-sirketi_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'Turkey',
    events: ['DMS'],
    email: 'info@bigsam.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/bigsam_company/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/bigsamcompany/',
      },
    ],
    sponsor: null,
    standNumber: 'C12a',
    standType: 'Space Only',
    website: 'https://www.bigsam.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '175',
    name: 'GNC',
    logo: 'https://a.storyblok.com/f/282702/4956a01d64/20250902094059_new-generation-food-supplements_cropped.jpg',
    industries: [
      'Nutrition',
      'Wellness',
      'Beauty',
      'Supplement Distributor',
      'Beauty & Wellness',
      'Distributor',
      'Fitness',
      'Pharmacy',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'newgen@gnc-mena.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/gnc_mena/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/gncmenacom',
      },
    ],
    sponsor: null,
    standNumber: 'G11c',
    standType: 'Space Only',
    website: 'https://www-gnc-mena.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '176',
    name: 'BODY DYNAMIC',
    logo: 'https://a.storyblok.com/f/282702/0a87844da2/20250902070740_the-one-fitness-co-ltd-_cropped.jpg',
    industries: ['Fitness', 'Equipment', 'Gym'],
    headquarters: 'Taiwan',
    events: ['DAI'],
    email: 'one-tiffany@umail.hinet.net',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/bodydynamicfit/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/bodydynamicfit',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCMYyvTVe_340RnDTGO5_5qQ',
      },
    ],
    sponsor: null,
    standNumber: 'A2',
    standType: 'Space Only',
    website: 'https://www.bodydynamicfit.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '177',
    name: 'Body Builder',
    logo: 'https://a.storyblok.com/f/282702/342c595025/20250828134516_dr-nutrition_cropped.jpg',
    industries: [
      'Fitness',
      'Apparel',
      'Gym Accessories',
      'Supplement Distributor',
      'Wellness',
      'Retailer FMCG',
      'Nutrition',
      'Gym',
      'Equipment',
      'Beauty',
      '⁠Association or Council',
      'Education & Training',
      'Fitness Franchise',
    ],
    headquarters: 'Germany',
    events: ['DMS'],
    email: 'sales@bodyb.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/body.builder.official/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/bodybuilder',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/bodybuilder300',
      },
    ],
    sponsor: null,
    standNumber: 'G15',
    standType: 'Space Only',
    website: 'https://bodyb.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '178',
    name: 'CARIBOU COFFEE',
    logo: 'https://a.storyblok.com/f/282702/61cfd1014c/20250828131543_al-sayer-retail_cropped.jpg',
    industries: ['Others'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'dinah@cariboucoffee.me',
    socials: null,
    sponsor: null,
    standNumber: 'G4B',
    standType: 'Space Only',
    website: 'https://www.cariboucoffee.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '179',
    name: 'BASIX',
    logo: 'https://a.storyblok.com/f/282702/b62bd291e0/20250828113721_sport-for-all-general-trading_cropped.jpg',
    industries: [
      'Fitness',
      'Recovery',
      'Nutrition',
      'Wellness',
      'Beauty & Wellness',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'support@basixnutrition.co.uk',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/basix.nutrition/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/basix-nutrition',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/basixnutrition/',
      },
    ],
    sponsor: 'Platinum Sponsor',
    standNumber: 'B14',
    standType: 'Space Only',
    website: 'https://basixnutrition.co.uk/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '180',
    name: 'De Cecco',
    logo: 'https://a.storyblok.com/f/282702/2a4ebb4ed6/20250826144215_f-lli-de-cecco-di-filippo-fara-san-martino-s-p-a-_cropped.jpg',
    industries: ['Nutrition'],
    headquarters: 'Italy',
    events: ['DMS', 'DAS'],
    email: 'helponline@dececco.it',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/dececco_pasta/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/f-lli-de-cecco-di-filippo---fara-san-martino-s-p-a-/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/PastaDeCecco/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCb2FfoUxca0gu70latE5AhA',
      },
    ],
    sponsor: null,
    standNumber: 'G9A',
    standType: 'Space Only',
    website: 'https://www.dececco.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Seventh batch - new 30 exhibitors (ids 181-210)
  {
    id: '181',
    name: 'OXYHELP',
    logo: 'https://a.storyblok.com/f/282702/ad6ab11edb/20250825094813_power-space-biohacking_cropped.jpg',
    industries: [
      'Beauty & Wellness',
      'Distributor',
      'Equipment',
      'Gym',
      'Fitness',
      'Wellness',
    ],
    headquarters: 'UAE',
    events: ['DAS', 'DAI'],
    email: 'info@oxyhelp.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/oxyhelp_uae',
      },
    ],
    sponsor: null,
    standNumber: 'L10',
    standType: 'Space Only',
    website: 'https://www.oxyhelp.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '182',
    name: 'sniffys.',
    logo: 'https://a.storyblok.com/f/282702/d4422a47e3/20250825085740_adfinity-ltd_cropped.jpg',
    industries: [
      'Fitness',
      'Pharmacy',
      'Recovery',
      'Equipment',
      'Gym',
      'Wellness',
      'Beauty & Wellness',
      'Equipment Distributor',
      'Gym Accessories',
    ],
    headquarters: 'Germany',
    events: ['DAS'],
    email: 'hello@sniffys.io',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/sniffys.io/',
      },
    ],
    sponsor: null,
    standNumber: 'C8b',
    standType: 'Space Only',
    website: 'https://www.sniffys.io',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '183',
    name: 'MyPT',
    logo: 'https://a.storyblok.com/f/282702/9ebcd85bbc/20250825081533_square-one-fitness_cropped.jpg',
    industries: [
      'Education & Training',
      'Gym',
      'Fitness',
      'Training Provider',
      'Nutrition',
      'Gym Accessories',
    ],
    headquarters: 'UAE',
    events: ['DAS', 'DAI'],
    email: 'contact@sqonefitness.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/mypt_me/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/sqonefitness/',
      },
    ],
    sponsor: null,
    standNumber: 'D3',
    standType: 'Space Only',
    website: 'https://mypt-me.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '184',
    name: 'XITE FITNESS',
    logo: 'https://a.storyblok.com/f/282702/832326de6d/20250822103622_xite-fitness-trading-llc_cropped.jpg',
    industries: [
      'Fitness',
      'Equipment Distributor',
      'Gym Accessories',
      'Wellness',
      'Gym',
      'Equipment',
      'Distributor',
      'Fitness Franchise',
      'Beauty & Wellness',
      'Others',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@xitefitness.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/xite__fitness/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/xitefitness',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/xitefitness',
      },
    ],
    sponsor: null,
    standNumber: 'F2A',
    standType: 'Space Only',
    website: 'https://xitefitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '185',
    name: 'SHADOW OF DEATH',
    logo: 'https://a.storyblok.com/f/282702/8d7e63b2b8/20250821143854_shadow-of-death_cropped.jpg',
    industries: ['Fitness', 'Nutrition'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'contact@shadowofdeathsupps.com',
    socials: null,
    sponsor: null,
    standNumber: 'F7b',
    standType: 'Space Only',
    website: 'https://www.shadowofdeathsupps.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '186',
    name: 'ABC NUTRITIONALS',
    logo: 'https://a.storyblok.com/f/282702/2ac95d7739/20250821091922_abc-nutrition-ltd_cropped.jpg',
    industries: ['Nutrition', 'Wellness', 'Supplement Distributor'],
    headquarters: null,
    events: ['DMS'],
    email: 'info@abcnutritionals.com',
    socials: [
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/abcnutritionals',
      },
    ],
    sponsor: null,
    standNumber: 'G9c',
    standType: 'Space Only',
    website: 'https://abcnutritionals.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '187',
    name: 'Myprotein',
    logo: 'https://a.storyblok.com/f/282702/bac91595fd/20250821075853_the-nutrition-limited_cropped.jpg',
    industries: ['Fitness', 'Nutrition', 'Gym', 'Gym Accessories', 'Wellness'],
    headquarters: 'UK',
    events: ['DAS'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'F6B',
    standType: 'Space Only',
    website: 'https://www.myprotein.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '188',
    name: 'CAULIFLOWER CULTURE',
    logo: 'https://a.storyblok.com/f/282702/bd56b35aa4/20250819122120_cauliflower-culture_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Fitness Franchise',
      'Wellness',
      'Education & Training',
      'Recovery',
    ],
    headquarters: null,
    events: ['DAS'],
    email: 'cauliflowerculture@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/cauliflowerculture',
      },
    ],
    sponsor: null,
    standNumber: 'H10C',
    standType: 'Space Only',
    website: 'https://cauliflower-culture.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '189',
    name: 'SheRuns',
    logo: 'https://a.storyblok.com/f/282702/737cb8fd37/20250820080631_plan-b_cropped.jpg',
    industries: ['Wellness', 'Others'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'connect@sheruns.me',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/sheruns.uae/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/she-runs-2025/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/sherunsuae',
      },
    ],
    sponsor: 'Strategic Partner',
    standNumber: 'J2A',
    standType: 'Space Only',
    website: 'https://www.planbadv.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '190',
    name: 'AMIX ADVANCED NUTRITION',
    logo: 'https://a.storyblok.com/f/282702/95c89441a3/20250819125100_amix-levante-slu_cropped.jpg',
    industries: ['Nutrition', 'Supplement Distributor'],
    headquarters: 'Spain',
    events: ['DMS'],
    email: 'info@amix.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/amixnutrition.official',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/amixnutrition.official',
      },
    ],
    sponsor: null,
    standNumber: 'F9',
    standType: 'Space Only',
    website: 'https://www.amix.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '191',
    name: 'FH FITNESS',
    logo: 'https://a.storyblok.com/f/282702/7a57afa80c/20250819111005_fh-fitness-equipment-trading-llc-opc_cropped.jpg',
    industries: [
      'Fitness',
      'Equipment Distributor',
      'Gym Accessories',
      'Equipment',
      'Distributor',
    ],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@fhfitness.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fhfitness.ae',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/fhfitness',
      },
    ],
    sponsor: null,
    standNumber: 'G2',
    standType: 'Space Only',
    website: 'https://www.fhfitness.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '192',
    name: 'MUSL BUDDIES',
    logo: 'https://a.storyblok.com/f/282702/fdd27bd5e3/20250818064642_musl-buddies-fze_cropped.jpg',
    industries: [
      'Apparel',
      'Fitness',
      'Retailer FMCG',
      'Gym Accessories',
      'Gym',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'support@muslbuddies.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/muslbuddies/',
      },
    ],
    sponsor: null,
    standNumber: 'A10a',
    standType: 'Space Only',
    website: 'https://www.muslbuddies.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '193',
    name: 'MATRIX',
    logo: 'https://a.storyblok.com/f/282702/ce7d68ecb1/20250811094702_johnson-health-tech-uae-llc_cropped.jpg',
    industries: [
      'Equipment Distributor',
      'Equipment',
      'Hospitality',
      'Fitness',
      'Technology',
      'Wellness',
      'Gym Accessories',
      'Education & Training',
    ],
    headquarters: 'USA',
    events: ['DAI'],
    email: 'marketing@uae.johnsonfitness.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/matrixfitness_middleeast/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/johnson-health-tech-middle-east',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/MatrixFitnessME',
      },
    ],
    sponsor: null,
    standNumber: 'B3',
    standType: 'Space Only',
    website: 'https://ae.matrixfitness.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '194',
    name: 'PURE FILTH',
    logo: 'https://a.storyblok.com/f/282702/5ad6c88dcc/20250809105356_pure-filth_cropped.jpg',
    industries: [
      'Fitness',
      'Pharmacy',
      'Beauty',
      'Nutrition',
      'Gym',
      'Wellness',
      'Beauty & Wellness',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'hello@getpurefilth.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/getpurefilth/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/pure-filth-mushrooms/',
      },
    ],
    sponsor: null,
    standNumber: 'H6a',
    standType: 'Space Only',
    website: 'https://www.getpurefilth.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '195',
    name: 'AuraLuxe Medical',
    logo: 'https://a.storyblok.com/f/282702/00a4659c86/20250801064123_auraluxe-medical_cropped.jpg',
    industries: ['Beauty & Wellness', 'Equipment', 'Beauty'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'tracy@kaiyanmedical.com',
    socials: null,
    sponsor: null,
    standNumber: 'L18',
    standType: 'Space Only',
    website: 'https://www.kaiyanmedical.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '196',
    name: 'LARA STAR',
    logo: 'https://a.storyblok.com/f/282702/6110ed6df9/20250731055304_yangzhou-seventar-sports-goods_cropped.jpg',
    industries: ['Gym Accessories', 'Fitness'],
    headquarters: 'China',
    events: ['DMS'],
    email: 'sales11@lara-star.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/larastar_official',
      },
    ],
    sponsor: null,
    standNumber: 'E8a',
    standType: 'Space Only',
    website: 'https://www.lara-star.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '197',
    name: 'GYMLECO',
    logo: 'https://a.storyblok.com/f/282702/d1ae747035/20250730063104_gymleco_cropped.jpg',
    industries: ['Equipment'],
    headquarters: 'Sweden',
    events: ['DAI'],
    email: 'contact@gymleco.se',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/gymleco/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/gymleco',
      },
      {
        logo: 'facebook',
        link: 'https://facebook.com/Gymleco',
      },
    ],
    sponsor: null,
    standNumber: 'D2',
    standType: 'Space Only',
    website: 'https://gymleco.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '198',
    name: 'AQUALY',
    logo: 'https://a.storyblok.com/f/282702/a983a31bf8/20250724135255_lyarabia-water-trading-llc_cropped.jpg',
    industries: ['Others', 'Retailer FMCG', 'Nutrition'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'o.white@lycompany.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/aqualy_me/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/ly-company-middle-east-aqualy',
      },
    ],
    sponsor: null,
    standNumber: 'J2e',
    standType: 'Space Only',
    website: 'https://aqualy.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '199',
    name: 'Wawi Inmovation',
    logo: 'https://a.storyblok.com/f/282702/5de0b4caad/20250724114603_wawi-inmovation-gmbh_cropped.jpg',
    industries: ['Fitness', 'Gym', 'Beauty', 'Nutrition'],
    headquarters: 'Germany',
    events: ['DAS'],
    email: 'info@wawi.com',
    socials: null,
    sponsor: null,
    standNumber: 'G6b',
    standType: 'Space Only',
    website: 'https://www.wawi.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '200',
    name: 'Scitec Nutrition',
    logo: 'https://a.storyblok.com/f/282702/103c6433be/20250721125155_scitec-nutrition_cropped.jpg',
    industries: [
      'Apparel',
      'Distributor',
      'Fitness',
      'Beauty & Wellness',
      'Supplement Distributor',
      'Nutrition',
    ],
    headquarters: 'Hungary',
    events: ['DMS'],
    email: 'info@biotechusa.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/scitecnutrition/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/scitecnutrition',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/Scitec.Hu',
      },
    ],
    sponsor: null,
    standNumber: 'E9',
    standType: 'Space Only',
    website: 'https://scitecnutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '201',
    name: 'LOVINDUBAI',
    logo: 'https://a.storyblok.com/f/282702/7186a35215/20250730085050_augustus-media-fz-llc-_cropped.jpg',
    industries: ['Media'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/lovindubai/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/lovindubai/',
      },
    ],
    sponsor: 'Media Partner',
    standNumber: 'H3E',
    standType: 'Space Only',
    website: 'https://lovin.co',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '202',
    name: 'YOUR Personal Training',
    logo: 'https://a.storyblok.com/f/282702/da5eb497e9/20250721082129_your-management-solutions-limited_cropped.jpg',
    industries: [
      'Fitness',
      'Technology',
      'Training Provider',
      'Education & Training',
      'Others',
    ],
    headquarters: 'UK',
    events: ['DAI'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/yourptuk/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/your-personal-training/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/yourptuk',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCtp6lMRLGSjrn-JwJ-HFn6g',
      },
    ],
    sponsor: 'Networking Party Sponsor',
    standNumber: '',
    standType: 'Space Only',
    website: 'https://www.yourpersonaltrainingsolutions.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '203',
    name: 'AGARI INTERNATIONAL',
    logo: 'https://a.storyblok.com/f/282702/2564d1fe14/20250720122208_agari-international-nl-bv_cropped.jpg',
    industries: [
      'Distributor',
      'Fitness',
      'Pharmacy',
      'Supplement Distributor',
    ],
    headquarters: 'Netherlands',
    events: ['DMS'],
    email: 'info@agarinl.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/meltz_dubai',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/agari-international-nl/',
      },
    ],
    sponsor: null,
    standNumber: 'C11b-4',
    standType: 'Space Only',
    website: 'https://www.agarinl.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '204',
    name: 'ENESYS PERFORMANCE',
    logo: 'https://a.storyblok.com/f/282702/82b1e72695/20250714225122_enesys-performance-ltd_cropped.jpg',
    industries: [
      'Fitness',
      'Fitness Franchise',
      'Education & Training',
      'Training Provider',
      'Gym',
    ],
    headquarters: null,
    events: ['DAS'],
    email: null,
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/enesys.performance',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/enesysperformance/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCMcdAag6GUApIrwyuaWW9dg',
      },
    ],
    sponsor: null,
    standNumber: 'H3c',
    standType: 'Space Only',
    website: 'https://enesysperformance.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '205',
    name: 'FITFUEL',
    logo: 'https://a.storyblok.com/f/282702/ace3965c6e/20250717115642_samara-general-trading_cropped.jpg',
    industries: [
      'Distributor',
      'Fitness',
      'Nutrition',
      'Retailer FMCG',
      'Wellness',
      'Supplement Distributor',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'info@fitfuel.ae',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fitfuelae',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/fitfuelae',
      },
    ],
    sponsor: null,
    standNumber: 'C9',
    standType: 'Space Only',
    website: 'https://www.fitfuel.ae',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '206',
    name: 'Real Pharm Group',
    logo: 'https://a.storyblok.com/f/282702/4867bda664/20250716091454_real-pharm-group-sp-z-o-o-_cropped.jpg',
    industries: [
      'Nutrition',
      'Supplement Distributor',
      'Pharmacy',
      'Gym',
      'Fitness',
    ],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'sales@realpharm.eu',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/real_pharm_nutrition/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/RealPharm/',
      },
    ],
    sponsor: null,
    standNumber: 'C11a',
    standType: 'Space Only',
    website: 'https://www.realpharm.eu',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '207',
    name: 'Gharieni Group',
    logo: 'https://a.storyblok.com/f/282702/26431d0260/20250716102049_gharieni-middle-east_cropped.jpg',
    industries: ['Equipment', 'Beauty & Wellness'],
    headquarters: 'Germany',
    events: ['DAI'],
    email: 'k.husseini@gharieni.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/gharienigroup/',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/user/Gharieni',
      },
    ],
    sponsor: null,
    standNumber: 'E1',
    standType: 'Space Only',
    website: 'https://www.gharieni.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '208',
    name: 'Annathletics',
    logo: 'https://a.storyblok.com/f/282702/3af44444a3/20250716081922_annathletics_cropped.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'annathletics.official@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/annathletics_official/',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/annathletics.official',
      },
    ],
    sponsor: null,
    standNumber: 'H5B',
    standType: 'Space Only',
    website: 'https://annathletics.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '209',
    name: 'PURELIFE TRADING',
    logo: 'https://a.storyblok.com/f/282702/f50d028baa/20250715112006_purelife-tradfing-fze-llc_cropped.jpg',
    industries: [
      'Distributor',
      'Fitness',
      'Gym',
      'Hospitality',
      'Nutrition',
      'Recovery',
      'Supplement Distributor',
      'Wellness',
      'Pharmacy',
    ],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'purelifetradingllc@gmail.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/purelifetrading',
      },
    ],
    sponsor: null,
    standNumber: 'H5d',
    standType: 'Space Only',
    website: 'https://www.purelifetrading.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '210',
    name: 'Kshine',
    logo: 'https://a.storyblok.com/f/282702/500x500/c5baead7b1/kshine.jpg',
    industries: ['Wellness'],
    headquarters: 'China',
    events: ['DAI'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'D8G',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Eighth batch - new 29 exhibitors (ids 211-239)
  {
    id: '211',
    name: 'Chenyang',
    logo: 'https://a.storyblok.com/f/282702/500x500/27961b6dd3/chenyang.jpg',
    industries: ['Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'D8D',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '212',
    name: 'Gao Sheng Wei Ye',
    logo: 'https://a.storyblok.com/f/282702/500x500/b46667389a/gs-vending.jpg',
    industries: ['Equipment Distributor', 'Nutrition'],
    headquarters: 'China',
    events: ['DAI'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'C11B-1',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '213',
    name: 'Minolta',
    logo: 'https://a.storyblok.com/f/282702/500x500/626474a077/minolta.jpg',
    industries: ['Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'C4B-2',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '214',
    name: 'Tianzhan Fitness',
    logo: 'https://a.storyblok.com/f/282702/500x500/92d131cea0/tzfit.jpg',
    industries: ['Equipment'],
    headquarters: 'China',
    events: ['DAI'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'B4-1',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '215',
    name: 'Gym Glory',
    logo: '',
    industries: [],
    headquarters: '',
    events: ['DMS'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'L21',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '216',
    name: 'Hyrox',
    logo: 'https://a.storyblok.com/f/282702/500x500/2ac1109553/hyrox.jpg',
    industries: [],
    headquarters: 'UAE',
    events: ['DMS', 'DAS'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/hyroxworld/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/hyroxworld/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCr7h-eYgYlWtwaxD7Fb55cw',
      },
    ],
    sponsor: null,
    standNumber: 'E5B',
    standType: 'Space Only',
    website: 'https://hyrox.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '217',
    name: 'Active Fitness Store',
    logo: 'https://a.storyblok.com/f/282702/500x500/656e6580db/active-fitness-store.jpg',
    industries: ['Equipment'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@activefitnessstore.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/activefitnessstore/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/activefitnessstore/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCRQWrcTK6zt7hJV-DylhI3A',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/activefitnessstore/',
      },
    ],
    sponsor: null,
    standNumber: 'E5A',
    standType: 'Space Only',
    website: 'https://activefitnessstore.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '218',
    name: 'Al Beed Trading',
    logo: 'https://a.storyblok.com/f/282702/500x500/da48738221/al-beed-trading.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/albeedtradingllc/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/albeed_trading/',
      },
    ],
    sponsor: null,
    standNumber: 'A9C',
    standType: 'Space Only',
    website: 'https://albeed.net/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '219',
    name: 'Team Nogs',
    logo: 'https://a.storyblok.com/f/282702/500x500/92778d9c51/team-nogs.jpg',
    industries: [],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'info@teamnogueiradubai.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/TeamNogueiraDubai',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/tndubai/',
      },
    ],
    sponsor: null,
    standNumber: 'H10B',
    standType: 'Space Only',
    website: 'https://teamnogueiradubai.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '220',
    name: 'Evogen - Hany Rambod',
    logo: 'https://a.storyblok.com/f/282702/500x500/7411f82e6d/evogen-hany.jpg',
    industries: ['Nutrition'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'cs@evogennutrition.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/EvogenNutrition/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/evogennutrition/?hl=en',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/evogen-nutrition/',
      },
    ],
    sponsor: null,
    standNumber: 'A15',
    standType: 'Space Only',
    website: 'https://www.evogennutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '221',
    name: 'Puzzle Supps',
    logo: 'https://a.storyblok.com/f/282702/500x500/fde5a1efd2/puzzle-supps.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'puzzlesupps88@gmail.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/people/Puzzle-Supps/61557684467518/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/puzzlesupps/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/@PuzzleSupps',
      },
    ],
    sponsor: null,
    standNumber: 'G14A',
    standType: 'Space Only',
    website: 'https://puzzlesupps.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '222',
    name: 'Kevin Levrone Signature Series',
    logo: 'https://a.storyblok.com/f/282702/500x500/26ea7d9c74/kevin-levrone-signature-series.jpg',
    industries: ['Nutrition'],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'shop@levrosupplements.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/officialkevinlevronesignatureseries/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/levrone_signature_series/',
      },
    ],
    sponsor: null,
    standNumber: 'F12',
    standType: 'Space Only',
    website: 'https://levrosupplements.com/gb/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '223',
    name: 'QNT Sport',
    logo: 'https://a.storyblok.com/f/282702/500x500/3a6cd2f40c/qnt.jpg',
    industries: ['Nutrition'],
    headquarters: '',
    events: ['DMS'],
    email: 'orders@qntsport.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/QNTSPORT',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/qntsportnutrition/?hl=fr',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/qnt-s-a-/?originalSubdomain=be',
      },
    ],
    sponsor: null,
    standNumber: 'C13A',
    standType: 'Space Only',
    website: 'https://www.qntsport.com/en/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '224',
    name: 'Fardad General Trading - Hecktor',
    logo: '',
    industries: [],
    headquarters: '',
    events: ['DMS'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'B7B',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '225',
    name: 'MMOOVVEE International',
    logo: 'https://a.storyblok.com/f/282702/500x500/564810918c/mmoovvee.jpg',
    industries: ['Wellness'],
    headquarters: '',
    events: ['DAI'],
    email: 'Support@mmoovvee.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/mmoovveeinternational/?hl=en',
      },
    ],
    sponsor: null,
    standNumber: 'L3',
    standType: 'Space Only',
    website: 'https://mmoovvee.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '226',
    name: 'Lululemon',
    logo: 'https://a.storyblok.com/f/282702/500x500/60abbe8e01/lululemon.jpg',
    industries: ['Apparel'],
    headquarters: 'Canada',
    events: ['DAS'],
    email: 'lululemon.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/lululemon',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/lululemon',
      },
    ],
    sponsor: null,
    standNumber: 'G8B',
    standType: 'Space Only',
    website: 'https://lululemon.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '227',
    name: 'Zumba',
    logo: 'https://a.storyblok.com/f/282702/500x500/2753d30cbb/zumba.jpg',
    industries: ['Fitness'],
    headquarters: 'USA',
    events: ['DAS'],
    email: 'support@zumba.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/zumba/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/zumba/',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/zumba/',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@zumba/',
      },
    ],
    sponsor: null,
    standNumber: 'J2B',
    standType: 'Space Only',
    website: 'https://zumba.com/en-US/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '228',
    name: 'Yava Nutrition',
    logo: 'https://a.storyblok.com/f/282702/500x500/43b479a686/yava-labs.jpg',
    industries: ['Nutrition'],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'info@yava-labs.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/yavalabs/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/yavalabs.official/',
      },
      {
        logo: 'whatsapp',
        link: 'https://api.whatsapp.com/send?phone=19294209437&text=Hi!%20I%20am%20contacting%20you%20for%20more%20information%20about%20your%20products.',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/channel/UCruo2hio5LyYVWk2tYiAAOw/',
      },
    ],
    sponsor: null,
    standNumber: 'D15A',
    standType: 'Space Only',
    website: 'https://yava-labs.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '229',
    name: 'Wana Sweets - Map Global',
    logo: 'https://a.storyblok.com/f/282702/500x500/10d92d95ba/wana-sweets-map-global.jpg',
    industries: ['Nutrition'],
    headquarters: 'Italy',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/wanafunctionalsweets/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/wana_sweets/',
      },
    ],
    sponsor: null,
    standNumber: 'L22',
    standType: 'Space Only',
    website: 'https://wanasweets.com/en/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '230',
    name: 'Trugge',
    logo: 'https://a.storyblok.com/f/282702/500x500/d73c54f079/trugge.jpg',
    industries: ['Equipment'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'service@trugge.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/truggecom',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/truggecom/',
      },
    ],
    sponsor: null,
    standNumber: 'F5A',
    standType: 'Space Only',
    website: 'http://www.trugge.com',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '231',
    name: 'The Beemine Lab UAE',
    logo: 'https://a.storyblok.com/f/282702/500x500/66a512e33f/the-beemine-lab-pharmapal-drug-store.jpg',
    industries: ['Beauty & Wellness'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'uae@thebeeminelab.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/people/Thebeeminelab/100063579488536/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/the.beemine.lab/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/beemine/',
      },
    ],
    sponsor: 'Platinum Sponsor',
    standNumber: 'G5B',
    standType: 'Space Only',
    website: 'https://thebeeminelab.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '232',
    name: 'Team One - Eliwell',
    logo: 'https://a.storyblok.com/f/282702/500x500/88da2aaa72/team-one-eliwell.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/beyondfitus/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/brittanyramos_ipepro/',
      },
    ],
    sponsor: null,
    standNumber: 'E13',
    standType: 'Space Only',
    website: 'https://teamonenutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '233',
    name: 'SSNC - Poles Nutrition',
    logo: 'https://a.storyblok.com/f/282702/500x500/d5be3cf9ec/ssnc.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'info@ssncindia.in',
    socials: [],
    sponsor: null,
    standNumber: 'B13',
    standType: 'Space Only',
    website: 'https://ssncdirect.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '234',
    name: 'Redz Corporation',
    logo: 'https://a.storyblok.com/f/282702/500x500/b3bc76467c/redz-corporation.jpg',
    industries: ['Gym Accessories'],
    headquarters: 'Pakistan',
    events: ['DAS'],
    email: 'redzfitness@gmail.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/redzfitnessgear/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/redzcorp/',
      },
    ],
    sponsor: null,
    standNumber: 'L19A',
    standType: 'Space Only',
    website: 'https://redzfitness.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '235',
    name: 'Quality Group WT',
    logo: 'https://a.storyblok.com/f/282702/500x500/78c5c4a301/quality-group.jpg',
    industries: [],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@qualitygroup.ae',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/qualitygulf/',
      },
    ],
    sponsor: null,
    standNumber: 'C7C',
    standType: 'Space Only',
    website: 'https://qualitygroup.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '236',
    name: 'Qimia Nutrition Middle East',
    logo: 'https://a.storyblok.com/f/282702/500x500/4f279d7d05/qimia-nutrition-qnt-trec-and-iron-max.jpg',
    industries: ['Supplement Distributor'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'support@qimia.om',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/olimpoman/',
      },
    ],
    sponsor: null,
    standNumber: 'D15',
    standType: 'Space Only',
    website: 'https://qimia.om/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '237',
    name: 'ProSupps USA',
    logo: 'https://a.storyblok.com/f/282702/500x500/1ba286539b/prosupps.jpg',
    industries: ['Nutrition'],
    headquarters: 'USA',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/prosupps/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/prosupps/',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/prosuppstv/',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@prosupps/',
      },
    ],
    sponsor: null,
    standNumber: 'A12B',
    standType: 'Space Only',
    website: 'https://prosupps.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '238',
    name: 'Olimp Labs',
    logo: 'https://a.storyblok.com/f/282702/500x500/063aada89d/olimp-labs.jpg',
    industries: ['Nutrition'],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'info@olimp-labs.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/olimpsportnutrition/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/olimp_sport_nutrition/',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/user/OlimpSportNutrition/',
      },
    ],
    sponsor: null,
    standNumber: 'G11D',
    standType: 'Space Only',
    website: 'https://olimpsport.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '239',
    name: 'New Rock',
    logo: 'https://a.storyblok.com/f/282702/500x500/cd86dc1299/new-rock.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/newrocksports.official/',
      },
    ],
    sponsor: 'Platinum Sponsor',
    standNumber: 'F12',
    standType: 'Space Only',
    website: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  // Final batch - new 16 exhibitors (ids 240-255)
  {
    id: '240',
    name: 'New Extreme Sports',
    logo: 'https://a.storyblok.com/f/282702/500x500/e60f4aa4ca/new-extreme-sports-trading.jpg',
    industries: ['Equipment Distributor', 'Supplement Distributor'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'sales@extremesportstrading.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/extremesportstradinguae/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/extremesportstradinguae/',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/channel/UCe_ooxGSeDyMDELnJXiWxnA/',
      },
    ],
    sponsor: null,
    standNumber: 'B4',
    standType: 'Space Only',
    website: 'https://extremesportstrading.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '241',
    name: 'Megafitness',
    logo: 'https://a.storyblok.com/f/282702/500x500/472889fece/mega-fitness.jpg',
    industries: ['Equipment Distributor'],
    headquarters: 'Greece',
    events: ['DAI'],
    email: 'bestellung@megafitness-shop.de',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/megafitnessshop/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/megafitness.shop/',
      },
    ],
    sponsor: null,
    standNumber: 'A1',
    standType: 'Space Only',
    website: 'https://megafitness.shop/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '242',
    name: 'Max Pump',
    logo: 'https://a.storyblok.com/f/282702/500x500/17e3f941d1/max-pumo-sport.jpg',
    industries: [],
    headquarters: '',
    events: ['DAI'],
    email: '',
    socials: [],
    sponsor: null,
    standNumber: 'A8A',
    standType: 'Space Only',
    website: 'https://maxpumpsport.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '243',
    name: 'JNK Nutrition',
    logo: 'https://a.storyblok.com/f/282702/500x500/57538cd41b/jnk-nutriiton.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'sales@jnknutrition.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/jnknutritionae/',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/jnk_nutrition/',
      },
      {
        logo: 'youtube',
        link: 'https://www.youtube.com/channel/UCzMjph6DmhPO7dMifaGTxRg',
      },
    ],
    sponsor: null,
    standNumber: 'C14',
    standType: 'Space Only',
    website: 'https://www.jnknutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '244',
    name: 'Infinis Nutrition',
    logo: 'https://a.storyblok.com/f/282702/500x500/b240836835/infinis-nutrition.jpg',
    industries: ['Nutrition'],
    headquarters: 'USA',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'instagram',
        link: 'https://instagram.com/infinisnutrition/',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@infinisnutrition/',
      },
    ],
    sponsor: null,
    standNumber: 'G13A',
    standType: 'Space Only',
    website: 'https://infinisnutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '245',
    name: 'Hype',
    logo: 'https://a.storyblok.com/f/282702/500x500/23fce24826/hype.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/hypeenergydrinks/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/hypeenergydrinks/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/hype-drinks/',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@hypeenergydrinks/',
      },
    ],
    sponsor: null,
    standNumber: 'D15',
    standType: 'Space Only',
    website: 'https://hype.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '246',
    name: 'Going All In',
    logo: 'https://a.storyblok.com/f/282702/500x500/2ef15ffe21/going-all-in.jpg',
    industries: ['Apparel'],
    headquarters: 'UAE',
    events: ['DAS'],
    email: 'admin@going-allin.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/goingallin.uae/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/goingallin.uae/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/going-all-in/',
      },
      {
        logo: 'whatsapp',
        link: 'https://api.whatsapp.com/send?phone=%2B923214205533',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/channel/UCwsJLmf4wLtqhdCpztkKaiw/',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@goingallinuae/',
      },
    ],
    sponsor: 'Main Fitness Stage Sponsor',
    standNumber: 'G7B',
    standType: 'Space Only',
    website: 'https://goingallin.co/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '247',
    name: 'Flex Wheeler Nutrition',
    logo: 'https://a.storyblok.com/f/282702/500x500/a01340a992/flex-wheeler-nutrition.jpg',
    industries: ['Nutrition'],
    headquarters: 'USA',
    events: ['DMS'],
    email: 'info@flexwheelernutrition.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/kenflexwheeler',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/flexwheeler.nutrition/',
      },
    ],
    sponsor: null,
    standNumber: 'A9A',
    standType: 'Space Only',
    website: 'https://flexwheelernutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '248',
    name: 'Enhance Fitness',
    logo: 'https://a.storyblok.com/f/282702/500x500/91541fbf57/enhance-fitness.jpg',
    industries: ['Fitness'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@enhancefitness.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/enhancedxb/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/enhancefitness/',
      },
    ],
    sponsor: 'Silver Sponsor',
    standNumber: 'A2A',
    standType: 'Space Only',
    website: 'https://www.enhancefitness.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '249',
    name: 'Dr Nutrition',
    logo: 'https://a.storyblok.com/f/282702/500x500/f42b96de48/dr-nutrition.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'customerservice@drnutrition.com',
    socials: [
      {
        logo: 'facebook',
        link: 'https://ar-ar.facebook.com/dnpface/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/dnpdubai/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/drnutrition/',
      },
      {
        logo: 'whatsapp',
        link: 'https://api.whatsapp.com/send/?phone=97142040734&text&type=phone_number&app_absent=0',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/@Dr.Nutrition/',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@dr_nutrition/',
      },
    ],
    sponsor: null,
    standNumber: 'G15',
    standType: 'Space Only',
    website: 'https://drnutrition.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '250',
    name: 'Fuel Up USA Inc.',
    logo: 'https://a.storyblok.com/f/282702/500x500/7eb50ede31/fuel-up.jpg',
    industries: ['Nutrition'],
    headquarters: 'Poland',
    events: ['DMS'],
    email: 'international@fuel-up.us',
    socials: [
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/fuelupvitamins',
      },
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/fuelup_vitamins/',
      },
    ],
    sponsor: null,
    standNumber: 'B12A',
    standType: 'Space Only',
    website: 'https://fuel-up.us/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '251',
    name: 'C5',
    logo: 'https://a.storyblok.com/f/282702/500x500/13f2ff21aa/c5.jpg',
    industries: [
      'Beauty & Wellness',
      'Fitness',
      'Gym',
      'Wellness',
      'Nutrition',
      'Supplement Distributor',
    ],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'ahmad@trostrading.com',
    socials: [
      {
        logo: 'instagram',
        link: 'https://www.instagram.com/ultramade.official/',
      },
      {
        logo: 'linkedin',
        link: 'https://www.linkedin.com/company/ultramade-nutrition-beverages-fze',
      },
      {
        logo: 'facebook',
        link: 'https://www.facebook.com/C5international',
      },
      {
        logo: 'youtube',
        link: 'http://www.youtube.com/@c5international',
      },
    ],
    sponsor: 'Energy Drink Sponsor',
    standNumber: 'B9',
    standType: 'Space Only',
    website: 'https://c5preworkout.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '252',
    name: 'Bombbar - Chikalab',
    logo: 'https://a.storyblok.com/f/282702/500x500/92a62764ee/bombar.jpg',
    industries: ['Nutrition'],
    headquarters: 'UAE',
    events: ['DMS'],
    email: 'store@bombbar.ae',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/bombbar.mena/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/bombbar.mena/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/bombbar/',
      },
      {
        logo: 'whatsapp',
        link: 'https://api.whatsapp.com/send/?phone=971588717959&text&type=phone_number&app_absent=0',
      },
      {
        logo: 'tiktok',
        link: 'https://tiktok.com/@bombbar.mena/',
      },
    ],
    sponsor: null,
    standNumber: 'C15',
    standType: 'Space Only',
    website: 'https://bombbar.ae/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '253',
    name: 'Beijing Worldboson Intl',
    logo: 'https://a.storyblok.com/f/282702/500x500/19667441f2/beijing-worldboson-intl.jpg',
    industries: [],
    headquarters: 'China',
    events: ['DAI', 'DMS'],
    email: 'info@worldboson.com',
    socials: [],
    sponsor: null,
    standNumber: 'A5, B4, B5, C4A, C4B, C6, C11A, D5C, D8A to P',
    standType: 'Space Only',
    website: 'https://worldboson.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
    parentExhibitorId: null,
  },
  {
    id: '254',
    name: 'Anovator Equipment',
    logo: 'https://a.storyblok.com/f/282702/500x500/9f3064981e/anovator-equipment.jpg',
    industries: ['Equipment'],
    headquarters: 'UAE',
    events: ['DAI'],
    email: 'info@anovator.com',
    socials: [],
    sponsor: null,
    standNumber: 'L17',
    standType: 'Space Only',
    website: 'https://anovator.com/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
  {
    id: '255',
    name: 'Active IQ',
    logo: 'https://a.storyblok.com/f/282702/500x500/4be64c3d4f/active-iq.jpg',
    industries: ['Education & Training'],
    headquarters: 'UK',
    events: ['DAI'],
    email: '',
    socials: [
      {
        logo: 'facebook',
        link: 'https://facebook.com/active.iq/',
      },
      {
        logo: 'instagram',
        link: 'https://instagram.com/activeiq/',
      },
      {
        logo: 'linkedin',
        link: 'https://linkedin.com/company/active-iq/',
      },
      {
        logo: 'youtube',
        link: 'https://youtube.com/user/theactiveiqchannel/',
      },
    ],
    sponsor: 'Education Partner',
    standNumber: 'B1A',
    standType: 'Space Only',
    website: 'https://activeiq.co.uk/',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    isFavorite: false,
  },
].map((exhibitor) => {
  if (exhibitor.headquarters === 'China' && exhibitor.id !== '253') {
    return { ...exhibitor, parentExhibitorId: '253' }
  }
  return { ...exhibitor, parentExhibitorId: null }
})
